
(function () {
  if (!window.location.pathname.includes("/products/regular-canvas-lacy-polley")) return;

  const url = new URL(window.location.href);

  if (!url.searchParams.has("utm_source")) {
    url.searchParams.set("utm_source", "patner");
    url.searchParams.set("utm_medium", "photography");
    url.searchParams.set("utm_campaign", "canvas_collab");
    url.searchParams.set("utm_content", "lacy_polley");
    window.history.replaceState({}, "", url.toString());
  }
})();
(function () {
  const COOKIE_NAME = "stored_utms";

  function getQueryParams() {
    return new URLSearchParams(window.location.search);
  }

  function setCookie(name, value, days = 7) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + "; expires=" + expires + "; path=/";
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? JSON.parse(decodeURIComponent(match[2])) : {};
  }

  const params = getQueryParams();

  const utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term"
  ];

  let existing = getCookie(COOKIE_NAME);
  let updated = { ...existing };

  let hasNewUTM = false;

  utmKeys.forEach(key => {
    if (params.has(key)) {
      updated[key] = params.get(key);
      hasNewUTM = true;
    }
  });

  if (hasNewUTM) {
    setCookie(COOKIE_NAME, updated);
  }
})();

if (window.fabric) {
    fabric.Object.prototype.hasControls = false;
    fabric.Object.prototype.hasBorders = false;
  }

function hidePdpPageLoader() {
  const loader = document.querySelector("[data-pdp-page-loader]");
  if (!loader || loader.dataset.hidden === "1") return;

  loader.dataset.hidden = "1";
  loader.classList.add("is-hidden");
  document.documentElement.classList.remove("pdp-page-loading");
  if (document.body) {
    document.body.classList.remove("pdp-page-loading");
  }

  window.setTimeout(() => {
    if (loader.parentNode) {
      loader.parentNode.removeChild(loader);
    }
  }, 420);
}

window.hidePdpPageLoader = hidePdpPageLoader;

if (document.readyState === "complete") {
  window.setTimeout(hidePdpPageLoader, 120);
} else {
  window.addEventListener("load", () => {
    window.setTimeout(hidePdpPageLoader, 120);
  }, { once: true });
}

window.setTimeout(hidePdpPageLoader, 8000);

const canvas = new fabric.Canvas("image-canvas");

const appState = {
  outerMargin: 0,
  innerPadding: 10,
  innerWidth: 200,
  innerHeight: 200,
  selectedWidth: 200,
  selectedHeight: 200,
  uploadedImage: null,
  scaleFactor: 1,
  angle: 0,
  zoom: 1.0,
  minZoom: 0.1,
  maxZoom: 3.0,
  clipPath: null,
  outerFrame: null,
  innerCanvas: null,
  borderSize: 0.75,
  borderColor: "#000000",
  canvasBgColor: "#ffffff",
  canvasBorderColor: "#00000060",
  canvasWidth: 0,
  canvasHeight: 0,
  newCanvasWidth: 0,
  newCanvasHeight: 0,
  imageWidth: 0,
  imageHeight: 0,
  newimageleft: 0,
  newimagetop: 0,
  border: 0,
  selectedEdgeType: "FitToEdge",

};

let threedPreviewTimer = null;
function triggerThreeDPreview() {
  if (threedPreviewTimer) clearTimeout(threedPreviewTimer);

  threedPreviewTimer = setTimeout(() => {
    try {
      if (typeof window.threedpreview === "function") {
        window.threedpreview();
      } else if (typeof window["3dpreview"] === "function") {
        window["3dpreview"]();
      }
    } catch (error) {
      console.error("Failed to run 3D preview trigger:", error);
    }
  }, 120);
}

let frameSizeRecommendationRefreshQueued = false;
let autoOrientationPreferenceInProgress = false;
function scheduleFrameSizeRecommendationRefresh() {
  if (frameSizeRecommendationRefreshQueued) return;

  frameSizeRecommendationRefreshQueued = true;
  window.requestAnimationFrame(() => {
    frameSizeRecommendationRefreshQueued = false;
    if (typeof window.refreshFrameSizeRecommendations === "function") {
      window.refreshFrameSizeRecommendations();
    }
  });
}

// ============================================
// HEIC/HEIF CONVERSION SUPPORT (for Chrome & non-Apple browsers)
// ============================================
let _heic2anyLoaded = false;
let _heic2anyLoading = false;
let _heic2anyLoadPromise = null;

/**
 * Dynamically loads the heic2any library from CDN (only loaded once, on demand).
 */
function loadHeic2Any() {
  if (_heic2anyLoaded && window.heic2any) return Promise.resolve();
  if (_heic2anyLoading && _heic2anyLoadPromise) return _heic2anyLoadPromise;

  _heic2anyLoading = true;
  _heic2anyLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
    script.onload = () => {
      _heic2anyLoaded = true;
      _heic2anyLoading = false;
      console.log('✅ heic2any library loaded');
      resolve();
    };
    script.onerror = (err) => {
      _heic2anyLoading = false;
      console.error('❌ Failed to load heic2any library:', err);
      reject(new Error('Failed to load heic2any library'));
    };
    document.head.appendChild(script);
  });
  return _heic2anyLoadPromise;
}

/**
 * Checks if a file is HEIC/HEIF by MIME type or extension.
 * Some browsers may report an empty MIME for HEIC files, so we also check extension.
 */
function isHeicFile(file) {
  if (!file) return false;
  const type = (file.type || '').toLowerCase();
  const name = (file.name || '').toLowerCase();
  return (
    type === 'image/heic' ||
    type === 'image/heif' ||
    name.endsWith('.heic') ||
    name.endsWith('.heif')
  );
}

/**
 * Converts a HEIC/HEIF file to a JPEG Blob.
 * Returns { blobUrl, blob, dataUrl } for use with Image, fabric, etc.
 */
async function convertHeicToJpeg(file) {
  console.log('🔄 Converting HEIC image to JPEG...');
  await loadHeic2Any();

  if (!window.heic2any) {
    throw new Error('heic2any library not available after loading');
  }

  const outputBlob = await window.heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.92
  });

  // heic2any can return an array or a single blob
  const resultBlob = Array.isArray(outputBlob) ? outputBlob[0] : outputBlob;
  const blobUrl = URL.createObjectURL(resultBlob);

  // Also create a data URL for fabric.js and data-attribute usage
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(resultBlob);
  });

  console.log('✅ HEIC converted to JPEG successfully');
  return { blobUrl, blob: resultBlob, dataUrl };
}

const previewSyncEvents = [
  "object:added",
  "object:removed",
  "object:modified",
  "object:moving",
  "object:scaling",
  "object:rotating"
];
function syncThreeDPreviewForCanvasChange(event) {
  if (event?.target?.name === "centerLine") return;
  triggerThreeDPreview();
}
previewSyncEvents.forEach((eventName) => {
  canvas.on(eventName, syncThreeDPreviewForCanvasChange);
});

// Disable image selection UI (border + dots) while keeping object movement enabled.
function disableImageSelectionUI(imageObj) {
  if (!imageObj) return;

  imageObj.set({
    selectable: true,
    evented: true,
    hasBorders: false,
    hasControls: false,
    borderColor: "transparent",
    cornerColor: "transparent",
    cornerStrokeColor: "transparent",
    cornerSize: 1,
    transparentCorners: true,
    lockRotation: true,
    lockScalingFlip: true,
    lockUniScaling: true
  });

  // Explicitly hide every control handle.
  imageObj.setControlsVisibility({
    tl: false,
    tr: false,
    bl: false,
    br: false,
    ml: false,
    mr: false,
    mt: false,
    mb: false,
    mtr: false
  });
}

function enforceNoSelectionUI(event) {
  const selectionTarget = event?.target || (event?.selected && event.selected[0]) || null;
  if (!selectionTarget || selectionTarget.type !== "image") return;
  disableImageSelectionUI(selectionTarget);
}

canvas.selection = false;
canvas.on("selection:created", enforceNoSelectionUI);
canvas.on("selection:updated", enforceNoSelectionUI);
canvas.on("object:moving", enforceNoSelectionUI);
// ============================
// CENTER GUIDELINES WITH SNAPPING
// ============================
let vCenterLine, hCenterLine;
const THRESHOLD = 10; // 4px threshold for snapping

// Function to create center lines (always visible)
function createCenterLines() {
  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;

  // Remove existing lines if any
  if (vCenterLine) canvas.remove(vCenterLine);
  if (hCenterLine) canvas.remove(hCenterLine);

  // Create vertical center line
  vCenterLine = new fabric.Line(
    [centerX, 0, centerX, canvas.height],
    {
      stroke: 'red',
      strokeWidth: 3,
      selectable: false,
      evented: false,
      opacity: 0, // Semi-transparent
      name: 'centerLine',
      strokeDashArray: [0, 0] // Dashed line for better visibility
    }
  );

  // Create horizontal center line
  hCenterLine = new fabric.Line(
    [0, centerY, canvas.width, centerY],
    {
      stroke: 'red',
      strokeWidth: 3,
      selectable: false,
      evented: false,
      opacity: 0, // Semi-transparent
      name: 'centerLine',
      strokeDashArray: [0, 0] // Dashed line for better visibility
    }
  );

  canvas.add(vCenterLine);
  canvas.add(hCenterLine);
  bringCenterLinesToFront();
  canvas.requestRenderAll();
}

// Function to update center lines position
function updateCenterLines() {
  if (!vCenterLine || !hCenterLine) {
    createCenterLines();
    return;
  }

  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;

  vCenterLine.set({
    x1: centerX,
    y1: 0,
    x2: centerX,
    y2: canvas.height
  });

  hCenterLine.set({
    x1: 0,
    y1: centerY,
    x2: canvas.width,
    y2: centerY
  });

  bringCenterLinesToFront();
  canvas.requestRenderAll();
}


const mockupPlacements = [
  { x: 0.3545, y: 0.199, w: 0.295, h: 0.375 },
  { x: 0.382, y: 0.354, w: 0.23, h: 0.292 },
  { x: 0.373, y: 0.106, w: 0.104, h: 0.132 },
  { x: 0.376, y: 0.488, w: 0.246, h: 0.311 },
];

const mockupState = {
  croppedWidth: 0,
  croppedHeight: 0
};

document.addEventListener("DOMContentLoaded", initWrapSelector);
window.addEventListener("load", initWrapSelector);

function normalizeWrapValue(value, fallback = "frontfit") {
  const normalized = String(value || "").trim().toLowerCase();

  switch (normalized) {
    case "black":
    case "mirrorwrap":
      return "mirrorwrap";
    case "white":
    case "blurwrap":
      return "blurwrap";
    case "fittoedge":
    case "fit":
      return "fit";
    case "frontfit":
      return "frontfit";
    default:
      return fallback;
  }
}

function storeSelectedWrap(value) {
  const normalized = normalizeWrapValue(value);
  sessionStorage.setItem("selectedWrap", normalized);
  return normalized;
}

function isMirrorWrapValue(value) {
  return normalizeWrapValue(value) === "mirrorwrap";
}

function isBlurWrapValue(value) {
  return normalizeWrapValue(value) === "blurwrap";
}

function isFitToEdgeWrapValue(value) {
  return normalizeWrapValue(value) === "fit";
}

function isFrontFitWrapValue(value) {
  return normalizeWrapValue(value) === "frontfit";
}

function initWrapSelector() {
  document
    .querySelectorAll('.wrap-option input[value="black"], .wrap-option input[value="white"]')
    .forEach((input) => {
      input.closest(".wrap-option")?.remove();
    });

  const options = Array.from(document.querySelectorAll('.wrap-option'));
  const controls = document.querySelector('.controls');

  if (!options.length) {
    retryInit();
    return;
  }

  const appState = {
    selectedWrap: "frontfit",
    selectedEdgeType: "FitToEdge"
  };

  /* ---------------- Controls ---------------- */
  function updateControlsDisplay(value) {
    if (!controls) return;
    controls.style.display = "flex";
  }

  /* ---------------- Initial Selection ---------------- */
  function applyInitialSelection() {

    let value = normalizeWrapValue(
      sessionStorage.getItem("selectedWrap") ||
      document.querySelector('.wrap-option input:checked')?.value ||
      "frontfit"
    );

    let input = document.querySelector(
      `.wrap-option input[value="${value}"]`
    );

    if (!input) {
      input =
        document.querySelector('.wrap-option input[value="frontfit"]') ||
        document.querySelector('.wrap-option input[value="fit"]') ||
        options[0]?.querySelector("input") ||
        null;
      value = normalizeWrapValue(input?.value);
    }

    if (!input) return false;

    const parent = input.closest('.wrap-option');
    if (!parent || parent.classList.contains('disabled')) return false;

    options.forEach(o => o.classList.remove('active'));
    parent.classList.add('active');

    input.checked = true;

    appState.selectedWrap = value;
    storeSelectedWrap(value);

    updateControlsDisplay(value);
    applyWrapEffects(value);

    return true;
  }

  /* ---------------- Click Handling ---------------- */
  options.forEach(opt => {
    opt.addEventListener('click', e => {
      if (opt.classList.contains('disabled')) return;
      e.preventDefault();

      options.forEach(o => {
        o.classList.remove('active');
        const i = o.querySelector('input');
        if (i) i.checked = false;
      });

      opt.classList.add('active');
      const input = opt.querySelector('input');
      if (!input) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      const value = normalizeWrapValue(input.value);

      appState.selectedWrap = value;
      storeSelectedWrap(value);

      updateControlsDisplay(value);
      applyWrapEffects(value);
      if (typeof scrollToPreviewOnMobile === 'function') {
        scrollToPreviewOnMobile();
      }
    });
  });

  /* ---------------- Wrap Effects ---------------- */
  function applyWrapEffects(value) {
    value = normalizeWrapValue(value || sessionStorage.getItem("selectedWrap"));

    if (isMirrorWrapValue(value)) {
      appState.selectedEdgeType = "MirrorWrap";
      coverFrame("black");
    }

    else if (isBlurWrapValue(value)) {
      appState.selectedEdgeType = "WhiteWrap";
      coverFrame("white");
    }

    else if (isFitToEdgeWrapValue(value)) {
      appState.selectedEdgeType = "FitToEdge";
      applyFitToEdgeWrapSelection();
    }

    else if (isFrontFitWrapValue(value)) {
      appState.selectedEdgeType = "FitToEdge";
      applyFrontFitWrapSelection();
    }
  }

  /* ---------------- Init ---------------- */
  applyInitialSelection();

  function retryInit() {
    setTimeout(initWrapSelector, 300);
  }
}

const uploadInput = document.getElementById("upload-image");
const uploadInputwrap = document.querySelector(".upload-wrapper");
const galleryWrapper = document.getElementById("galleryWrapper");
const galleryWrapperbtn = document.querySelector(".left-panel-orange-banner");

const galleryWrappermain = document.querySelector(".left-pdp-sticky");
const customForm = document.getElementById("custom-image-form");

let canvasOpsLoadingCount = 0;
let canvasOpsShownAt = 0;
let canvasOpsHideTimer = null;

function getCanvasOpsLoaderHost() {
  return document.querySelector("#splitView .canvas-panel.left-panel")
    || document.getElementById("custom-image-form")
    || document.querySelector(".left-pdp-sticky");
}

function ensureCanvasOpsLoader(host) {
  if (!host) return null;

  const styleId = "canvas-ops-loader-style";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      .canvas-ops-loader{
        position:absolute;
        inset:0;
        z-index:0;
        display:none;
        align-items:center;
        justify-content:center;
        flex-direction:column;
        gap:8px;
        background: #17171D;
        backdrop-filter: blur(2px);
      }
      .canvas-ops-loader.active{ display:flex; }
      .canvas-ops-loader__spinner{
        width:40px;
        height:40px;
        border:3px solid rgba(255,255,255,0.24);
        border-top-color:#fff;
        border-radius:50%;
        animation: canvasOpsSpin 0.9s linear infinite;
        display:block !important;
      }
      .canvas-ops-loader__text{
        color:#fff;
        font-size:12px;
        letter-spacing:0.02em;
      }
      @keyframes canvasOpsSpin { to { transform: rotate(360deg); } }
      @media (max-width: 749px){
        .canvas-ops-loader__spinner{ width:36px; height:36px; }
        .canvas-ops-loader__text{ font-size:11px; }
      }
    `;
    document.head.appendChild(style);
  }

  let loader = host.querySelector("#canvasOpsLoader");
  if (!loader) {
    if (window.getComputedStyle(host).position === "static") {
      host.style.position = "relative";
    }
    loader = document.createElement("div");
    loader.id = "canvasOpsLoader";
    loader.className = "canvas-ops-loader";
    loader.innerHTML = '<div class="canvas-ops-loader__spinner"></div>';
    host.appendChild(loader);
  }
  return loader;
}

function showCanvasOpsLoader() {
  canvasOpsLoadingCount += 1;
  const host = getCanvasOpsLoaderHost();
  const loader = ensureCanvasOpsLoader(host);
  if (!loader) return;

  if (canvasOpsHideTimer) {
    clearTimeout(canvasOpsHideTimer);
    canvasOpsHideTimer = null;
  }

  canvasOpsShownAt = Date.now();
  loader.classList.add("active");
}

function hideCanvasOpsLoader() {
  canvasOpsLoadingCount = Math.max(0, canvasOpsLoadingCount - 1);
  if (canvasOpsLoadingCount > 0) return;

  const host = getCanvasOpsLoaderHost();
  const loader = host ? host.querySelector("#canvasOpsLoader") : null;
  if (!loader) return;

  const minVisibleMs = 280;
  const postCompleteDelayMs = 2000;
  const elapsed = Date.now() - canvasOpsShownAt;
  const wait = Math.max(0, minVisibleMs - elapsed) + postCompleteDelayMs;

  canvasOpsHideTimer = setTimeout(() => {
    if (canvasOpsLoadingCount === 0) {
      loader.classList.remove("active");
    }
    canvasOpsHideTimer = null;
  }, wait);
}

function waitForCanvasRenderComplete() {
  return new Promise((resolve) => {
    if (!canvas || typeof canvas.on !== "function" || typeof canvas.off !== "function") {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
      return;
    }

    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      try {
        canvas.off("after:render", onAfterRender);
      } catch (e) { }
      requestAnimationFrame(resolve);
    };

    const onAfterRender = () => finish();
    try {
      canvas.on("after:render", onAfterRender);
      canvas.requestRenderAll();
    } catch (e) { }

    setTimeout(finish, 260);
  });
}

canvas.on("object:scaling", function () {
  updateMovementConstraints();
  updatePositionInfo();
});

canvas.on("object:rotating", function () {
  updateMovementConstraints();
  updatePositionInfo();
});

document.querySelectorAll(".image-conform-btn").forEach(div => {
  div.style.pointerEvents = "none";
  div.style.opacity = "0.5";
});

function getImagePosition() {
  if (!appState.uploadedImage) return null;

  const img = appState.uploadedImage;
  const left = img.left - img.getScaledWidth() / 2;
  const top = img.top - img.getScaledHeight() / 2;
  const right = left + img.getScaledWidth();
  const bottom = top + img.getScaledHeight();

  return {
    left: left,
    top: top,
    right: right,
    bottom: bottom,
    width: img.getScaledWidth(),
    height: img.getScaledHeight(),
    scale: (img.scaleX * 100) / 100,
    angle: img.angle,
  };
}

// Add movement constraint functions
function setMovementConstraints() {
  if (!appState.uploadedImage) return;

  const img = appState.uploadedImage;
  const canvasWidth = appState.selectedWidth || canvas.getWidth();
  const canvasHeight = appState.selectedHeight || canvas.getHeight();
  const width = img.getScaledWidth();
  const height = img.getScaledHeight();

  img.originX = "center";
  img.originY = "center";

  if (width <= canvasWidth) {
    img.left = canvasWidth / 2;
  } else {
    const minLeft = canvasWidth - (width / 2);
    const maxLeft = width / 2;
    img.left = Math.min(maxLeft, Math.max(minLeft, img.left));
  }

  if (height <= canvasHeight) {
    img.top = canvasHeight / 2;
  } else {
    const minTop = canvasHeight - (height / 2);
    const maxTop = height / 2;
    img.top = Math.min(maxTop, Math.max(minTop, img.top));
  }

  img.setCoords();
  canvas.requestRenderAll();
}

function updateMovementConstraints() {
  if (!appState.uploadedImage) return;

  setMovementConstraints();
}

document.addEventListener("DOMContentLoaded", function () {
  const boostBtn = document.querySelector(".boost-img-btn");
  const conformBtn = document.querySelector(".image-conform-btn");

  if (!boostBtn || !conformBtn) return;

  function updateDisplay() {
    const boostDisplay = window.getComputedStyle(boostBtn).display;

    if (boostDisplay === "none") {
      conformBtn.style.display = "flex";
    } else if (boostDisplay === "flex") {
      conformBtn.style.display = "none";
    }
  }
  updateDisplay();

  const observer = new MutationObserver(updateDisplay);

  observer.observe(boostBtn, {
    attributes: true,
    attributeFilter: ["style", "class"],
    subtree: false
  });
  // Attach click handler to boost button to reset uploaded image
  boostBtn.addEventListener('click', resetUploadedImage);

  window.addEventListener("resize", updateDisplay);
});

function updatePositionInfo() {
  const pos = getImagePosition();
  
  if (!pos) return;

  const size = `${appState.originalWidth}x${appState.originalHeight}`;

  document.getElementById("position-left").textContent = `${pos.left}`;
  document.getElementById("position-top").textContent = `${pos.top}`;
  document.getElementById("position-right").textContent = `${pos.right}`;
  document.getElementById("position-bottom").textContent = `${pos.bottom}`;
  document.getElementById("img-width").textContent = `${pos.width}`;
  document.getElementById("img-height").textContent = `${pos.height}`;
  document.getElementById("img-scale").textContent = pos.scale;
  document.getElementById("img-angle").textContent = `${pos.angle}°`;

  const imgwidth = pos.width || 0;
  const imgheight = pos.height || 0;
  const rvalue = document.getElementById("r")?.textContent || 1;
  const imgtop = pos.top || 0;
  const imgleft = pos.left || 0;
  const cvswElement = document.getElementById("cvs-w")?.textContent || 0;
  const cvshElement = document.getElementById("cvs-h")?.textContent || 0;
  const imageratio = Number((imgwidth / imgheight).toFixed(2));
  const finalw = (imgwidth * rvalue);
  const finalh = (imgheight * rvalue);
  const finalt = (imgtop * rvalue);
  const finall = (imgleft * rvalue);

  const currentimgw = finalw / 100;
  const currentimgh = finalh / 100;

  const filewvalue = document.getElementById("img-file-w")?.textContent || 0;
  const filehvalue = document.getElementById("img-file-h")?.textContent || 0;

  const dpiW = filewvalue && currentimgw ? filewvalue / currentimgw : 0;
  const dpiH = filehvalue && currentimgh ? filehvalue / currentimgh : 0;
  const dpi = (dpiW + dpiH) / 2;

  appState.finall = finall;
  appState.finalt = finalt;
  appState.finalw = finalw;
  appState.finalh = finalh;
  appState.dpi = dpi;
  appState.printimghight = currentimgh;
  appState.printimgwidth = currentimgw;
  const newcanvasW = (appState.extendwidth * appState.dpi);
  appState.newCanvasWidth = newcanvasW;
  const newcanvasH = (appState.extendheight * appState.dpi);
  appState.newCanvasHeight = newcanvasH;
  const newborder = (0.75 * appState.dpi);
  appState.newBorder = newborder;
  const imageleft = ((finall * appState.dpi) / 100);
  appState.newimageleft = imageleft;
  const imagetop = ((finalt * appState.dpi) / 100);
  appState.newimagetop = imagetop;
  appState.imageWidth = filewvalue;
  appState.imageheight = filehvalue;

  updateZoomControlsState();
  updateDpiDisplay();
  document.getElementById("final-dpi").textContent = dpi.toFixed(2);
  document.getElementById("img-f-w").textContent = finalw;
  document.getElementById("img-f-h").textContent = finalh;
  document.getElementById("f-t").textContent = finalt;
  document.getElementById("f-l").textContent = finall;
  document.getElementById("img-ratio").textContent = imageratio;
  document.getElementById("current-img-w").textContent = currentimgw;
  document.getElementById("current-img-h").textContent = currentimgh;
  scheduleFrameSizeRecommendationRefresh();

  const hiddenimg = document.getElementById("frame-img-position");
  const orientationRadio = document.querySelector('input[name="orientation"]:checked');
  const orientation = orientationRadio ? orientationRadio.value : "portrait";
  if (orientation == "portrait") {
    if (hiddenimg) {
      hiddenimg.value = JSON.stringify({
        area_width: cvswElement,
        area_height: cvshElement,
        width: finalw,
        height: finalh,
        top: finalt,
        left: finall,
      });
    }
  }
  else if (orientation == "landscape") {
    if (hiddenimg) {
      hiddenimg.value = JSON.stringify({
        area_width: cvshElement,
        area_height: cvswElement,
        width: finalw,
        height: finalh,
        top: finalt,
        left: finall,
      });
    }
  }

  triggerThreeDPreview();
  if (typeof window.renderFlatFrontPreview === "function") {
    window.renderFlatFrontPreview();
  }
}

function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b);
}

// const dpiElements = document.querySelectorAll(".dpi-num");
// const iconElements = document.querySelectorAll(".dpi-state-icon");
const boostBtn = document.querySelector(".boost-img-btn");

boostBtn.style.display = "none";

function updateDpiDisplay() {

  // const dpiElement = document.querySelector(".dpi-num");
  // const iconElements = document.querySelectorAll(".dpi-state-icon");
  const boostBtn = document.querySelector(".boost-img-btn");
  const confirmBtn = document.querySelector(".image-conform-btn");


  const currentDpi = Number((appState.dpi || 0).toFixed(2));


  if (!boostBtn) return;

  // iconElements.forEach(el => {
  //   el.innerHTML = "";
  // });

  if (currentDpi > 0 && currentDpi < 30) {

    boostBtn.style.display = "flex";
    boostBtn.classList.add("show");

  } else if (currentDpi >= 30) {


    boostBtn.classList.remove("show");
    boostBtn.style.display = "none";

  } else if (currentDpi === 0) {
    boostBtn.classList.remove("show");

    setTimeout(() => {
      if (!boostBtn.classList.contains("show")) {
        boostBtn.style.display = "none";
        if (confirmBtn) {
          confirmBtn.style.display = "flex";
        }
      }
    }, 300);
  }
}

function updateFrameFromPixels(width, height, width1, height1) {
  canvas.setWidth(width + appState.outerMargin * 2);
  canvas.setHeight(height + appState.outerMargin * 2);

  // Fit canvas wrapper to the currently visible flat-view panel instead of a fixed square box.
  const canvasW = width + appState.outerMargin * 2;
  const canvasH = height + appState.outerMargin * 2;
  if (window.fitFlatViewCanvasToPanel) {
    window.fitFlatViewCanvasToPanel(canvasW, canvasH);
  } else {
    const maxDisplayPx = 200;
    const aspectRatio = canvasW / canvasH;
    let dispW;
    let dispH;
    if (aspectRatio >= 1) {
      dispW = maxDisplayPx;
      dispH = Math.round(maxDisplayPx / aspectRatio);
    } else {
      dispH = maxDisplayPx;
      dispW = Math.round(maxDisplayPx * aspectRatio);
    }
    canvas.wrapperEl.style.width = dispW + 'px';
    canvas.wrapperEl.style.height = dispH + 'px';
    canvas.wrapperEl.style.maxWidth = dispW + 'px';
    canvas.wrapperEl.style.maxHeight = dispH + 'px';
    canvas.getElement().style.width = '100%';
    canvas.getElement().style.height = '100%';
    if (canvas.upperCanvasEl) {
      canvas.upperCanvasEl.style.width = '100%';
      canvas.upperCanvasEl.style.height = '100%';
    }
  }
  const frnheight = appState.originalHeight;
  const frmwidth = appState.originalWidth;
  let size = `${frmwidth}x${frnheight}`;

  const sortedSize = [frmwidth, frnheight].sort((a, b) => a - b).join("x");

  let innerPadding = 0;

  appState.innerWidth = width - innerPadding * 2;
  appState.innerHeight = height - innerPadding * 2;

  canvas.clear();
  canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));
  if (appState.uploadedImage) {
    appState.uploadedImage.clipPath = null;
    appState.uploadedImage.originX = 0;
    appState.uploadedImage.originY = 0;
    appState.uploadedImage.left = 0;
    appState.uploadedImage.top = 0;
    appState.uploadedImage.scaleToWidth(width);
    appState.uploadedImage.scaleToHeight(height);

    canvas.add(appState.uploadedImage);
    canvas.setActiveObject(appState.uploadedImage);
  }

  const borderSize = innerPadding;

  function drawBorderOnTop() {
    const ctx = canvas.contextTop;
    if (!ctx) return;

    canvas.clearContext(canvas.contextTop);

    const bw = canvas.getWidth();
    const bh = canvas.getHeight();

    ctx.save();


    const dashOffset = 1;
    ctx.setLineDash([30, 20]);
    // Scale lineWidth proportionally to canvas size so the border appears
    // visually consistent regardless of which size variant is selected.
    // Reference: ~200px CSS display size → target ~2px visual line width.
    ctx.lineWidth = Math.min(12, Math.round(bw / 200));
    ctx.strokeStyle = "#000";

    ctx.beginPath(); ctx.moveTo(0, dashOffset); ctx.lineTo(bw, dashOffset); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0, bh - dashOffset); ctx.lineTo(bw, bh - dashOffset); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(dashOffset, 0); ctx.lineTo(dashOffset, bh); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(bw - dashOffset, 0); ctx.lineTo(bw - dashOffset, bh); ctx.stroke();


    ctx.beginPath(); ctx.moveTo(0, borderSize + dashOffset); ctx.lineTo(bw, borderSize + dashOffset); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0, bh - borderSize - dashOffset); ctx.lineTo(bw, bh - borderSize - dashOffset); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(borderSize + dashOffset, 0); ctx.lineTo(borderSize + dashOffset, bh); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(bw - borderSize - dashOffset, 0); ctx.lineTo(bw - borderSize - dashOffset, bh); ctx.stroke();

    ctx.setLineDash([]);


    ctx.fillStyle = "#ffffff00";

    ctx.fillRect(0, 0, bw, borderSize);
    ctx.fillRect(0, bh - borderSize, bw, borderSize);
    ctx.fillRect(0, borderSize, borderSize, bh - borderSize * 2);
    ctx.fillRect(bw - borderSize, borderSize, borderSize, bh - borderSize * 2);


    // ctx.fillStyle = "black";
    // const fontSize = 8;
    // ctx.font = `${fontSize}px sans-serif`;
    // ctx.textAlign = "center";
    // ctx.textBaseline = "middle";

    // // Top & bottom
    // ctx.fillText("SIDE AND BACK", bw / 2, borderSize / 2);
    // ctx.fillText("SIDE AND BACK", bw / 2, bh - borderSize / 2);

    // // Left
    // ctx.save();
    // ctx.translate(borderSize / 2, bh / 2);
    // ctx.rotate(Math.PI / 2);
    // ctx.fillText("SIDE AND BACK", 0, 0);
    // ctx.restore();

    // // Right
    // ctx.save();
    // ctx.translate(bw - borderSize / 2, bh / 2);
    // ctx.rotate(-Math.PI / 2);
    // ctx.fillText("SIDE AND BACK", 0, 0);
    // ctx.restore();

    ctx.restore();
  }

  window.drawBorderOnTop = drawBorderOnTop;

  canvas.off("after:render");
  canvas.on("after:render", drawBorderOnTop);
  canvas.requestRenderAll();
  updatePositionInfo();
  updateCenterLines();
}

function bringCenterLinesToFront() {
  if (vCenterLine) {
    canvas.moveTo(vCenterLine, 9999);
  }
  if (hCenterLine) {
    canvas.moveTo(hCenterLine, 9999);
  }
  canvas.requestRenderAll();
}
canvas.on('after:render', function () {
  bringCenterLinesToFront();
});

function removeBorderFromTop() {
  const ctx = canvas.contextTop;
  if (!ctx) return;
  canvas.clearContext(ctx);
  canvas.requestRenderAll();
}
window.removeBorderFromTop = removeBorderFromTop;

function coverFrame1() {
  if (!appState.uploadedImage) return;

  const img = appState.uploadedImage;
  const W = img.width || (img._element && img._element.naturalWidth) || 0;
  const H = img.height || (img._element && img._element.naturalHeight) || 0;
  if (W <= 0 || H <= 0) return;

  const frontW = appState.innerWidth > 0 ? appState.innerWidth : appState.selectedWidth;
  const frontH = appState.innerHeight > 0 ? appState.innerHeight : appState.selectedHeight;
  if (frontW <= 0 || frontH <= 0) return;

  // Cover: fill the entire front face (largest axis wins)
  const coverScale = Math.max(frontW / W, frontH / H);
  if (!isFinite(coverScale) || coverScale <= 0) return;

  const baseScale = getBaseScale();
  if (baseScale <= 0 || !isFinite(baseScale)) return;

  const coverZoom = coverScale / baseScale;
  if (!isFinite(coverZoom) || coverZoom <= 0) return;

  // Expand maxZoom to cover level so enforceMinimumDpi (called by the button handler)
  // does not clamp the zoom back down via the 3× hard cap — only DPI limits apply.
  if (coverZoom > appState.maxZoom) {
    appState.maxZoom = coverZoom;
  }

  img.scaleX = coverScale;
  img.scaleY = coverScale;
  appState.scaleFactor = coverScale;
  appState.zoom = coverZoom;

  img.set({
    left: appState.selectedWidth / 2,
    top: appState.selectedHeight / 2,
    originX: 'center',
    originY: 'center'
  });

  updateMovementConstraints();
  img.setCoords();
  canvas.requestRenderAll();
  updatePositionInfo(); // refreshes appState.dpi before the caller enforces DPI limits
  drawBorderOnTop();
  updateCenterLines();
}

function FitFrontFrame() {

  if (!appState.uploadedImage) return;

  const img = appState.uploadedImage;
  const orientationRadio = document.querySelector('input[name="orientation"]:checked');
  const orientation = orientationRadio ? orientationRadio.value : "portrait";

  let canvasWidth, canvasHeight;
  let W, H;
  let scaleX, scaleY;

  if (orientation === "portrait") { // portrait

    canvasWidth = appState.selectedWidth;
    canvasHeight = appState.selectedHeight;

    W = img.width;
    H = img.height;

    scaleX = appState.innerWidth / W;
    scaleY = appState.innerHeight / H;
  }
  else {

    canvasWidth = appState.selectedWidth;
    canvasHeight = appState.selectedHeight;

    W = img.width;
    H = img.height;

    scaleX = appState.innerWidth / W;
    scaleY = appState.innerHeight / H;

  }

  let newScale = Math.max(scaleX, scaleY);
  if (!isFinite(newScale) || newScale <= 0) newScale = 1;

  // Expand maxZoom so DPI-based clamping (not the hard 3× cap) controls the ceiling.
  const baseScale = getBaseScale();
  const coverZoom = baseScale > 0 ? newScale / baseScale : appState.zoom;
  if (isFinite(coverZoom) && coverZoom > appState.maxZoom) {
    appState.maxZoom = coverZoom;
  }

  img.scaleX = newScale;
  img.scaleY = newScale;
  appState.scaleFactor = newScale;

  const centerX = canvasWidth / 2;
  const centerY = canvasHeight / 2;

  img.set({
    left: centerX,
    top: centerY,
    originX: 'center',
    originY: 'center'
  });

  updateMovementConstraints();
  centerImage();
  img.setCoords();
  updatePositionInfo();
  canvas.requestRenderAll();
  setTimeout(() => {
    syncZoomSlider();
  }, 100);
  drawBorderOnTop();

}
function coverFrame(bgColor) {

  if (!isEdgesEnabled()) {
    return;
  }

  if (!bgColor) bgColor = "white";

  bgColor = bgColor.toLowerCase() === "black" ? "black" : "white";

  if (bgColor === "black") {
    appState.canvasBorderColor = "#000";
  }
  else if (bgColor === "white") {
    appState.canvasBorderColor = "#fff";
  }
  else {
    appState.canvasBorderColor = "#fff";
  }

  canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));
  if (!appState.uploadedImage) return;

  const img = appState.uploadedImage;
  const orientationRadio = document.querySelector('input[name="orientation"]:checked');
  const orientation = orientationRadio ? orientationRadio.value : "portrait";

  let canvasWidth, canvasHeight;
  let W, H;
  let scaleX, scaleY;

  if (orientation === "portrait") { // portrait

    canvasWidth = appState.selectedWidth;
    canvasHeight = appState.selectedHeight;

    W = img.width;
    H = img.height;

    scaleX = appState.innerWidth / W;
    scaleY = appState.innerHeight / H;
  }
  else {

    canvasWidth = appState.selectedWidth;
    canvasHeight = appState.selectedHeight;

    W = img.width;
    H = img.height;

    scaleX = appState.innerWidth / W;
    scaleY = appState.innerHeight / H;

  }

  let newScale = Math.max(scaleX, scaleY);
  if (!isFinite(newScale) || newScale <= 0) newScale = 1;

  img.scaleX = newScale;
  img.scaleY = newScale;
  appState.scaleFactor = newScale;

  const centerX = canvasWidth / 2;
  const centerY = canvasHeight / 2;

  img.set({
    left: centerX,
    top: centerY,
    originX: 'center',
    originY: 'center'
  });

  updateMovementConstraints();
  centerImage();
  img.setCoords();
  updatePositionInfo();
  canvas.requestRenderAll();

  const coverClamped = enforceMinimumDpi(MIN_PRINT_DPI);
  if (coverClamped) showZoomLimitMessage();
  updateDpiDisplay();
  syncZoomSlider();
  updateZoomControlsState();

  drawBorderOnTop();
}

function fitImageToFrame(cover = false) {
  if (!appState.uploadedImage) {
    return;
  }

  const W = appState.uploadedImage.width;
  const H = appState.uploadedImage.height;

  const scaleX = appState.selectedWidth / W;
  const scaleY = appState.selectedHeight / H;

  let newScale = cover ? Math.max(scaleX, scaleY) : Math.min(scaleX, scaleY);
  if (!isFinite(newScale) || newScale <= 0) {
    newScale = 1;
  }

  if (cover) {
    const baseScale = getBaseScale();
    const coverZoom = baseScale > 0 ? newScale / baseScale : appState.zoom;
    if (isFinite(coverZoom) && coverZoom > appState.maxZoom) {
      appState.maxZoom = coverZoom;
    }
  }

  appState.uploadedImage.scaleX = newScale;
  appState.uploadedImage.scaleY = newScale;
  appState.scaleFactor = newScale;

  updateMovementConstraints();
  centerImage();
  appState.uploadedImage.setCoords();
  updatePositionInfo();
  appState.canvasBorderColor = "#00000060";
  drawBorderOnTop();
  setTimeout(() => {
    syncZoomSlider();
  }, 100);

  canvas.requestRenderAll();
}

function centerImage() {
  if (!appState.uploadedImage) return;
  const centerX = appState.selectedWidth / 2;
  const centerY = appState.selectedHeight / 2;
  appState.uploadedImage.originX = "center";
  appState.uploadedImage.originY = "center";
  appState.uploadedImage.left = centerX;
  appState.uploadedImage.top = centerY;
  appState.uploadedImage.setCoords();
  canvas.requestRenderAll();
  setTimeout(() => {
    syncZoomSlider();
  }, 100);

  updatePositionInfo();
}

// document.getElementById("zoomIn").addEventListener("click", () => {
//   if (appState.uploadedImage) {
//     appState.scaleFactor *= 1.1;
//     appState.uploadedImage.scaleX = appState.scaleFactor;
//     appState.uploadedImage.scaleY = appState.scaleFactor;
//     appState.uploadedImage.setCoords();
//     updateMovementConstraints();
//     centerImage();
//     updatePositionInfo();
//     syncZoomSlider(); // Add this to update the slider
//   }
// });
// document.getElementById("zoomOut").addEventListener("click", () => {
//   if (appState.uploadedImage) {
//     // Allow unlimited zoom out by removing any minimum check
//     appState.scaleFactor *= 0.9;
//     appState.uploadedImage.scaleX = appState.scaleFactor;
//     appState.uploadedImage.scaleY = appState.scaleFactor;
//     appState.uploadedImage.setCoords();
//     updateMovementConstraints();
//     centerImage();
//     updatePositionInfo();
//     syncZoomSlider(); // Add this to update the slider
//   }
// });

function updateFrameSize(selectedOption) {
  // Get orientation selection
  const selectedRadio = document.querySelector('input[name="orientation"]:checked');
  const selectedOrientation = selectedRadio ? selectedRadio.value : "portrait";
  const selectedsize = document.querySelector('input[name="frameSize"]:checked');
  // Get frame size data from selected option
  const originalsize = selectedOption.getAttribute("data-original-size");
  const [width1, height1] = originalsize.split("x").map(Number);

  document.querySelectorAll(".selected-size").forEach(el => {
    el.textContent = selectedsize.value;
  });

  let dataratio;
  let size;
  if (window.innerWidth < 680) {
    size = selectedOption.getAttribute("data-original-size");
    dataratio = selectedOption.getAttribute("data-ratio-mobile");
  } else {
    size = selectedOption.getAttribute("data-original-size");
    dataratio = selectedOption.getAttribute("data-ratio-desktop");
  }

  const frmsize = selectedOption.getAttribute("data-frmsize");
  const [width, height] = size.split("x").map(Number);
  const [frmwidth, frmheight] = frmsize.replace(/″/g, '').split('×').map(s => Number(s.trim()));

  // Calculate extended dimensions
  const extendwidth = frmwidth + 3;
  const extendheight = frmheight + 3;

  // Set values based on orientation
  if (selectedOrientation === "portrait") {
    appState.originalWidth = width1;
    appState.originalHeight = height1;
    appState.selectedWidth = width;
    appState.selectedHeight = height;
    appState.extendheight = extendheight;
    appState.extendwidth = extendwidth;
  } else { // landscape
    appState.originalWidth = height1;
    appState.originalHeight = width1;
    appState.selectedWidth = height;
    appState.selectedHeight = width;
    appState.extendheight = extendwidth;
    appState.extendwidth = extendheight;
  }

  // Update UI elements
  updateFrameFromPixels(appState.selectedWidth, appState.selectedHeight, appState.originalWidth, appState.originalHeight);

  const cvswElement = document.getElementById("cvs-w");
  const cvshElement = document.getElementById("cvs-h");
  const orgWElement = document.getElementById("org-w");
  const orgHElement = document.getElementById("org-h");
  const frnWElement = document.getElementById("frm-w");
  const frmHElement = document.getElementById("frm-h");
  const ratioElement = document.getElementById("r");

  if (orgWElement) orgWElement.textContent = appState.originalWidth;
  if (orgHElement) orgHElement.textContent = appState.originalHeight;
  if (frnWElement) frnWElement.textContent = appState.selectedWidth;
  if (frmHElement) frmHElement.textContent = appState.selectedHeight;
  if (ratioElement) ratioElement.textContent = dataratio;
  if (cvswElement) cvswElement.textContent = appState.originalWidth;
  if (cvshElement) cvshElement.textContent = appState.originalHeight;

  // Handle canvas updates
  canvas.setWidth(appState.selectedWidth);
  canvas.setHeight(appState.selectedHeight);

  // Update all canvas objects
  canvas.getObjects().forEach(obj => {
    obj.set({
      scaleX: obj.scaleX,
      scaleY: obj.scaleY,
      left: obj.left,
      top: obj.top
    });
    obj.setCoords();
  });

  canvas.renderAll();

  // Handle uploaded image if exists
  if (appState.uploadedImage) {
    appState.uploadedImage.clipPath = appState.clipPath;
    canvas.add(appState.uploadedImage);
    FitFrontFrame();
  }

  updatePositionInfo();

  // Handle wrap option
  const checkedWrap = document.querySelector('.wrap-option input:checked');
  appState.selectedWrap = normalizeWrapValue(
    checkedWrap ? checkedWrap.value : sessionStorage.getItem("selectedWrap")
  );
  storeSelectedWrap(appState.selectedWrap);

  if (isMirrorWrapValue(appState.selectedWrap)) {
    coverFrame("black");
  } else if (isBlurWrapValue(appState.selectedWrap)) {
    coverFrame("white");
  } else if (isFitToEdgeWrapValue(appState.selectedWrap)) {
    applyFitToEdgeWrapSelection();
  } else if (isFrontFitWrapValue(appState.selectedWrap)) {
    applyFrontFitWrapSelection();
  }

  // After auto-fit on size/orientation change, ensure print DPI does not fall below the limit.
  enforceMinimumDpi(MIN_PRINT_DPI);

  // DPI display logic
  updateDpiDisplay();
}

// Mobile sticky pricing bar: reveal after user scrolls 40% of page
(function () {
  if (window.innerWidth > 989) return;

  const pricingBar = document.querySelector('.product-pricing-section-main-wrap');
  if (!pricingBar) return;

  let ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      const scrolled = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? scrolled / docHeight : 0;
      pricingBar.classList.toggle('pricing-sticky-visible', pct >= 0.3);
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Re-check on resize in case user rotates device
  window.addEventListener('resize', function () {
    if (window.innerWidth > 989) {
      pricingBar.classList.add('pricing-sticky-visible');
      window.removeEventListener('scroll', onScroll);
    }
  }, { passive: true });
}());

// Function to handle orientation radio button changes
function handleOrientationChange() {
  // Get the currently selected frame size option
  const selectedSizeOption = document.querySelector('#frameSizeOptions [name="frameSize"]:checked');
  if (selectedSizeOption) {
    updateFrameSize(selectedSizeOption);
  }
}

function getPreferredOrientationForImage(imageLike) {
  const width = Number(
    imageLike?.width ||
    imageLike?.naturalWidth ||
    imageLike?._originalElement?.naturalWidth ||
    imageLike?._element?.naturalWidth ||
    0
  );
  const height = Number(
    imageLike?.height ||
    imageLike?.naturalHeight ||
    imageLike?._originalElement?.naturalHeight ||
    imageLike?._element?.naturalHeight ||
    0
  );

  if (width > height) return "landscape";
  if (height > width) return "portrait";
  return null;
}

function applyUploadedImageOrientationPreference(imageLike) {
  const preferredOrientation = getPreferredOrientationForImage(imageLike);
  if (!preferredOrientation) return false;

  const orientationInput = document.querySelector(
    `#frameOrientationOptions input[name="orientation"][value="${preferredOrientation}"]`
  );

  if (!orientationInput || orientationInput.checked) {
    return false;
  }

  autoOrientationPreferenceInProgress = true;
  try {
    orientationInput.checked = true;
    orientationInput.dispatchEvent(new Event("change", { bubbles: true }));
  } finally {
    autoOrientationPreferenceInProgress = false;
  }
  return true;
}

// Event listeners
document.getElementById("frameSizeOptions").addEventListener("change", function (e) {
  if (e.target.name === "frameSize") {
    updateFrameSize(e.target);
  }
});

document.getElementById("frameOrientationOptions").addEventListener("change", function (e) {
  if (e.target.name === "orientation") {
    handleOrientationChange();
    if (typeof scrollToPreviewOnMobile === 'function') {
      scrollToPreviewOnMobile();
    }
  }
});

// Initialize on load
window.addEventListener("load", () => {
  const selectedOption = document.querySelector('#frameSizeOptions [name="frameSize"]:checked');
  if (selectedOption) {
    updateFrameSize(selectedOption);
  }

  // Add orientation change listeners to radio buttons
  const orientationRadios = document.querySelectorAll('input[name="orientation"]');
  orientationRadios.forEach(radio => {
    radio.addEventListener('change', (e) => {
      handleOrientationChange();
      if (typeof scrollToPreviewOnMobile === 'function') {
        scrollToPreviewOnMobile();
      }
    });
  });
});


window.addEventListener("load", () => {
  const selectedOption = document.querySelector('#frameOrientationOptions [ name="orientation" ]:checked');
  if (selectedOption) {
    updateFrameSize(selectedOption);
  }
});

canvas.on('object:moving', function (e) {
  const obj = e.target;

  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;

  // Get object center point
  const objCenter = obj.getCenterPoint();

  // Calculate distances from center
  const distX = Math.abs(objCenter.x - centerX);
  const distY = Math.abs(objCenter.y - centerY);

  // Remove existing center lines first
  if (vCenterLine) {
    canvas.remove(vCenterLine);
    vCenterLine = null;
  }
  if (hCenterLine) {
    canvas.remove(hCenterLine);
    hCenterLine = null;
  }

  // Check if object should snap to vertical center
  if (distX < THRESHOLD) {
    // For center-origin objects, just set left to centerX
    obj.set({
      left: centerX
    });

    // Create and show vertical center line
    vCenterLine = new fabric.Line(
      [centerX, 0, centerX, canvas.height],
      {
        stroke: 'red',
        strokeWidth: 5,
        selectable: false,
        evented: false,
        opacity: 1, // Slightly transparent
        name: 'centerLine'
      }
    );

    canvas.add(vCenterLine);
    // Ensure the line is on top
    canvas.moveTo(vCenterLine, 9999);
  }

  // Check if object should snap to horizontal center
  if (distY < THRESHOLD) {
    // For center-origin objects, just set top to centerY
    obj.set({
      top: centerY
    });

    // Create and show horizontal center line
    hCenterLine = new fabric.Line(
      [0, centerY, canvas.width, centerY],
      {
        stroke: 'red',
        strokeWidth: 5,
        selectable: false,
        evented: false,
        opacity: 1, // Slightly transparent
        name: 'centerLine'
      }
    );

    canvas.add(hCenterLine);
    // Ensure the line is on top
    canvas.moveTo(hCenterLine, 9999);
  }

  updateMovementConstraints();
  updatePositionInfo();
  obj.setCoords();

  // If object was snapped, we need to render
  if (distX < THRESHOLD || distY < THRESHOLD) {
    canvas.requestRenderAll();
  }
});

// Add this function to always keep center lines on top
canvas.on('object:added', function (e) {
  if (e.target.name === 'centerLine') {
    canvas.moveTo(e.target, 9999);
  }
});

// Also update your object:modified event to properly handle lines
canvas.on('object:modified', function (e) {
  // Only remove center lines if we're modifying a non-line object
  if (e.target.name !== 'centerLine') {
    if (vCenterLine) {
      canvas.remove(vCenterLine);
      vCenterLine = null;
    }
    if (hCenterLine) {
      canvas.remove(hCenterLine);
      hCenterLine = null;
    }
  }

  updatePositionInfo();
  canvas.requestRenderAll();
});


function uploadImageToAPI(file) {
  const formData = new FormData();
  const userId = window.shopifyCustomerId || "guest";
  const sessionId = getLocalStorage1Day("sessionId") || "none";
  formData.append('file', file);
  formData.append('customerId', userId);
  formData.append('sessionId', sessionId);
  formData.append('megamenu', "true");
  console.log(file);
  fetch(`${window.Prompt2Prints.apiBase}/upload-image`, {
    method: "POST",
    headers: {
      "x-api-key": window.Prompt2Prints.apiKey
    },
    body: formData
  })
    .then(res => res.json())
    .then(data => {
      // ✅ Store cloudfrontLink in localStorage
      if (data?.cloudfrontLink) {
        localStorage.setItem("pdpUploadedImage", data.cloudfrontLink);
      } else {
        console.warn("cloudfrontLink not found in API response");
      }
      const imageUpscale = document.querySelector('input[name="properties[_pdp-allow-upscale]"]');
      const imageUpscaletag = document.querySelector('input[name="properties[_pdp-img-tag]"]');

      if (!imageUpscale || !imageUpscaletag) {
        console.warn("Upscale inputs not found");
        return;
      }

      const flag = (data.flag || "").toLowerCase();

      if (flag === "standard") {
        imageUpscale.value = "true";
        imageUpscaletag.value = "Standard";
      }
      else if (flag === "professional") {
        imageUpscale.value = "false";
        imageUpscaletag.value = "Professional";
      }
      else {
        imageUpscale.value = "";
        imageUpscaletag.value = "";
      }

      // Optional: also update attribute for Shopify forms
      imageUpscale.setAttribute("value", imageUpscale.value);
      imageUpscaletag.setAttribute("value", imageUpscaletag.value);
    })
    .catch(err => {
      console.error("Image upload failed:", err);
    });
}

uploadInput.addEventListener("change", async function (e) {
  const file = e.target.files[0];
  if (!file) return;

  const allowedTypes = [
    "image/jpeg",
    "image/png",
    "image/heic",
    "image/heif"
  ];

  // Also allow by extension if MIME type is empty (some browsers don't set it for HEIC)
  const isAllowed = allowedTypes.includes(file.type) || isHeicFile(file);

  if (!isAllowed) {
    alert("Only JPEG, PNG, or HEIC images are allowed.");
    uploadInput.value = "";
    return;
  }
const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB
  if (file.size > MAX_FILE_SIZE_BYTES) {
    alert("Your image exceeds the 20 MB limit. Please upload a smaller file.");
    uploadInput.value = "";
    return;
  }
  showCanvasOpsLoader();
  try {
    appState.uploadimgsize = +(file.size / (1024 * 1024)).toFixed(2);

    // ============================================
    // HEIC CONVERSION: convert to JPEG if needed
    // ============================================
    let processFile = file;
    let processDataUrl = null;

    if (isHeicFile(file)) {
      try {
        const { blob, dataUrl } = await convertHeicToJpeg(file);

        // Create a new File-like blob for the API upload
        processFile = new File([blob], file.name.replace(/\.hei[cf]$/i, ".jpg"), {
          type: "image/jpeg"
        });
        processDataUrl = dataUrl;
      } catch (err) {
        console.error("HEIC conversion failed:", err);
        alert("Failed to convert HEIC image. Please try a JPEG or PNG file instead.");
        uploadInput.value = "";
        return;
      }
    }

    // Send image to API (use the converted file if HEIC was converted)
    uploadImageToAPI(processFile);

    // Function to handle the loaded image data URL
    function handleImageDataUrl(imageDataUrl) {
      return new Promise((resolve, reject) => {
        const mainImgWrap = document.querySelector(".main-img-wrap");
        if (mainImgWrap) {
          mainImgWrap.setAttribute("data-main-img", imageDataUrl);
        }

        fabric.Image.fromURL(imageDataUrl, function (fabricImg) {
          try {
            appState.uploadedImage = fabricImg;

            const imgfileWElement = document.getElementById("img-file-w");
            const imgfileHElement = document.getElementById("img-file-h");

            if (imgfileWElement) imgfileWElement.textContent = fabricImg.width;
            if (imgfileHElement) imgfileHElement.textContent = fabricImg.height;

            fabricImg.set({
              originX: "center",
              originY: "center",
              clipPath: appState.clipPath
            });
            disableImageSelectionUI(fabricImg);

            canvas.add(fabricImg);
            const didAutoSelectOrientation = applyUploadedImageOrientationPreference(fabricImg);
            setMovementConstraints();
            canvas.setActiveObject(fabricImg);
            canvas.moveTo(fabricImg, 2);
            if (!didAutoSelectOrientation) {
              handleOrientationChange();
            }
            syncZoomSlider();

            canvas.requestRenderAll();
            requestAnimationFrame(resolve);
          } catch (error) {
            reject(error);
          }
        });
      });
    }

    // If we already have a data URL from HEIC conversion, use it directly
    if (processDataUrl) {
      galleryWrapper.style.display = "none";
      if (galleryWrapperbtn) galleryWrapperbtn.style.display = "none";
      galleryWrappermain.style.gridTemplateRows = "max-content";
      uploadInputwrap.style.display = "none";
      customForm.style.display = "block";

      await handleImageDataUrl(processDataUrl);

      document.querySelectorAll(".image-conform-btn").forEach(div => {
        div.style.pointerEvents = "auto";
        div.style.opacity = "1";
      });
      const resetBtn = document.getElementById("resetUploadBtn");
      if (resetBtn) resetBtn.style.display = "";
    } else {
      // Normal flow for JPEG/PNG: use Image + FileReader
      const dataUrl = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = function (f) {
            resolve(f.target.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(processFile);
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(processFile);
      });

      galleryWrapper.style.display = "none";
      if (galleryWrapperbtn) galleryWrapperbtn.style.display = "none";
      galleryWrappermain.style.gridTemplateRows = "max-content";
      uploadInputwrap.style.display = "none";
      customForm.style.display = "block";

      await handleImageDataUrl(dataUrl);

      document.querySelectorAll(".image-conform-btn").forEach(div => {
        div.style.pointerEvents = "auto";
        div.style.opacity = "1";
      });
      const resetBtn = document.getElementById("resetUploadBtn");
      if (resetBtn) resetBtn.style.display = "";
    }
  } catch (error) {
    console.error("Failed to process uploaded image:", error);
  } finally {
    await waitForCanvasRenderComplete();
    hideCanvasOpsLoader();
    // Re-trigger previews after canvas is fully settled — early canvas events
    // fire during upload before orientation/sizing operations complete, so we
    // force a fresh update here once everything is done.
    setTimeout(function () {
      if (typeof window.setPreviewMode === "function") {
        window.setPreviewMode("3d", true);
      }
      triggerThreeDPreview();
      if (typeof window.renderFlatFrontPreview === "function") {
        window.renderFlatFrontPreview();
      }
    }, 300);
  }
});


function resetUploadedImage() {
  if (appState.uploadedImage) {
    canvas.remove(appState.uploadedImage);
    appState.uploadedImage = null;
  }

      const boostBtn = document.querySelector(".boost-img-btn");
  canvas.clear();
  canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));
  if (typeof createCenterLines === "function") createCenterLines();

  document.querySelectorAll(".image-conform-btn").forEach(div => {
    div.style.pointerEvents = "none";
    div.style.opacity = "0.5";
  });
boostBtn.classList.remove("show");
    boostBtn.style.display = "none";
  galleryWrapper.style.display = "";
  if (galleryWrapperbtn) galleryWrapperbtn.style.display = "";
  galleryWrappermain.style.gridTemplateRows = "";
  uploadInputwrap.style.display = "";
  customForm.style.display = "none";

  if (uploadInput) uploadInput.value = "";

  const resetBtn = document.getElementById("resetUploadBtn");
  if (resetBtn) resetBtn.style.display = "none";

  const syncModeKeys = ["pdpUploadedImage", "pdp-select-img", "select-print-image", "frame-select-img", "nonuser-image"];
  syncModeKeys.forEach(function (key) {
    try { localStorage.removeItem(key); } catch (e) {}
  });

  try {
    const url = new URL(window.location.href);
    if (url.searchParams.has("syncMode") || url.searchParams.has("syncimage")) {
      url.searchParams.delete("syncMode");
      url.searchParams.delete("syncimage");
      history.replaceState(null, "", url.pathname + url.search);
    }
  } catch (e) {}

  const flatPreviewWrap = document.querySelector("[data-flat-front-preview]");
  if (flatPreviewWrap) {
    flatPreviewWrap.classList.add("is-empty");
    const faces = flatPreviewWrap.querySelectorAll(".flat-preview-face");
    faces.forEach(function (f) { f.style.backgroundImage = ""; });
  }

  setTimeout(function () {
    triggerThreeDPreview();
    if (typeof window.renderFlatFrontPreview === "function") {
      window.renderFlatFrontPreview();
    }
  }, 100);

}

window.resetUploadedImage = resetUploadedImage;

const slider = document.getElementById("zoomSlider");
const zoomInBtn = document.getElementById("zoomIn");
const zoomOutBtn = document.getElementById("zoomOut");
const zoomLabel = document.getElementById("zoomLabel");

const canvasW = parseFloat(document.getElementById("frm-w")?.textContent) || 1;
const canvasH = parseFloat(document.getElementById("frm-h")?.textContent) || 1;

let imgWidthInches = 6;
let imgHeightInches = 4;
let scale = 1;

function isEdgesEnabled() {
  const mirrorCheckbox = document.getElementById("mirror-wrap");
  const blurCheckbox = document.getElementById("blur-wrap");

  const mirrorChecked = mirrorCheckbox ? mirrorCheckbox.checked : false;
  const blurChecked = blurCheckbox ? blurCheckbox.checked : false;

  return mirrorChecked || blurChecked;
}

function updateSliderBackground(slider) {
  if (!slider) return;

  const value = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;

  const currentDpi = Number((appState.dpi || 0).toFixed(2));

  let backgroundColor;
  if (currentDpi < 30) {
    backgroundColor = `linear-gradient(to right, #1F8FE5 ${value}%, rgb(255, 255, 255) ${value}%)`;
    slider.classList.add('dpi-warning-slider');
  } else {
    backgroundColor = `linear-gradient(to right, #1F8FE5 ${value}%, rgb(255, 255, 255) ${value}%)`;
    slider.classList.remove('dpi-warning-slider');
  }

  slider.style.background = backgroundColor;
}

const MIN_PRINT_DPI = 30;
let zoomLimitToastTimer = null;
let zoomLimitToastEl = null;

function getCurrentImageZoom() {
  if (!appState.uploadedImage) return appState.zoom || 1;

  const baseScale = getBaseScale();
  if (baseScale <= 0 || !isFinite(baseScale)) return appState.zoom || 1;

  const currentZoom = appState.uploadedImage.scaleX / baseScale;
  if (!isFinite(currentZoom) || currentZoom <= 0) return appState.zoom || 1;

  return currentZoom;
}

function getMaxZoomForMinDpi(minDpi = MIN_PRINT_DPI) {
  const currentDpi = Number(appState.dpi || 0);
  const currentZoom = getCurrentImageZoom();

  if (!isFinite(currentDpi) || currentDpi <= 0 || !isFinite(currentZoom) || currentZoom <= 0) {
    return appState.maxZoom;
  }

  // DPI is inversely proportional to zoom, so max zoom at target DPI:
  // targetZoom = currentZoom * (currentDpi / minDpi)
  const targetZoom = currentZoom * (currentDpi / minDpi);

  if (!isFinite(targetZoom) || targetZoom <= 0) return appState.maxZoom;

  return Math.max(appState.minZoom, Math.min(appState.maxZoom, targetZoom));
}

function clampZoomByDpi(newZoom, minDpi = MIN_PRINT_DPI) {
  const boundedZoom = Math.max(appState.minZoom, Math.min(appState.maxZoom, newZoom));
  const dpiLimitedMaxZoom = getMaxZoomForMinDpi(minDpi);
  return Math.max(appState.minZoom, Math.min(boundedZoom, dpiLimitedMaxZoom));
}

function getDynamicMaxZoom() {
  return getMaxZoomForMinDpi(MIN_PRINT_DPI);
}

function isAtDynamicMaxZoom(epsilon = 0.0001) {
  const currentZoom = getCurrentImageZoom();
  const dynamicMax = getDynamicMaxZoom();
  return currentZoom >= (dynamicMax - epsilon);
}

function getZoomLimitToastElement() {
  if (zoomLimitToastEl) return zoomLimitToastEl;

  const el = document.createElement("div");
  el.id = "zoom-limit-toast";
  el.style.cssText = `
    position: fixed;
    left: 50%;
    bottom: 130px;
    transform: translateX(-50%);
    background: rgba(20, 20, 20, 1);
    color: #fff;
    font-size: 12px;
    padding: 8px 12px;
    border-radius: 8px;
    z-index: 9999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.15);
    white-space: nowrap;
  `;
  el.textContent = "You reached max zoom for image resolution";
  document.body.appendChild(el);
  zoomLimitToastEl = el;
  return el;
}

function showZoomLimitMessage() {
  const toast = getZoomLimitToastElement();
  toast.style.opacity = "1";

  if (zoomLimitToastTimer) {
    clearTimeout(zoomLimitToastTimer);
  }

  zoomLimitToastTimer = setTimeout(() => {
    toast.style.opacity = "0";
    zoomLimitToastTimer = null;
  }, 1200);
}

function updateZoomControlsState() {
  const slider = document.getElementById("zoomSlider");
  const zoomInBtn = document.getElementById("zoomIn");
  const dynamicMaxZoom = getDynamicMaxZoom();

  if (slider) {
    slider.min = String(appState.minZoom * 100);
    slider.max = String(Math.round(dynamicMaxZoom * 100));
    slider.value = String(Math.round(getCurrentImageZoom() * 100));
    updateSliderBackground(slider);
  }

  if (zoomInBtn) {
    if (isAtDynamicMaxZoom()) {
      zoomInBtn.style.opacity = "0.5";
      zoomInBtn.style.cursor = "not-allowed";
    } else {
      zoomInBtn.style.opacity = "1";
      zoomInBtn.style.cursor = "pointer";
    }
  }
}

function enforceMinimumDpi(minDpi = MIN_PRINT_DPI) {
  if (!appState.uploadedImage) return false;

  const currentZoom = getCurrentImageZoom();
  const targetZoom = clampZoomByDpi(currentZoom, minDpi);

  if (!isFinite(targetZoom) || targetZoom <= 0) return false;
  if (targetZoom >= (currentZoom - 0.000001)) return false;

  updateZoom(targetZoom);
  updatePositionInfo();
  syncZoomSlider();
  updateZoomControlsState();
  return true;
}

function isZoomAllowed(newZoom) {
  const requested = Math.max(appState.minZoom, Math.min(appState.maxZoom, newZoom));
  const allowed = clampZoomByDpi(requested, MIN_PRINT_DPI);
  return allowed >= (requested - 0.000001);
}

function initZoomSlider() {
  const slider = document.getElementById("zoomSlider");
  if (!slider) return;
  slider.min = String(appState.minZoom * 100);
  slider.max = String(Math.round(getDynamicMaxZoom() * 100));
  slider.value = String(appState.zoom * 100);
  updateSliderBackground(slider);
  syncZoomSlider();
}
document.addEventListener("DOMContentLoaded", function () {
  initZoomSlider();

  // Zoom slider event
  const slider = document.getElementById("zoomSlider");
  if (slider) {
    slider.addEventListener("input", function () {
      handleZoomSlider(this);
    });
  }

  // Zoom button events
  const zoomInBtn = document.getElementById("zoomIn");
  const zoomOutBtn = document.getElementById("zoomOut");

  if (zoomInBtn) {
    zoomInBtn.addEventListener("click", zoomIn);
  }

  if (zoomOutBtn) {
    zoomOutBtn.addEventListener("click", zoomOut);
  }
});

function calculateCoverZoom() {
  if (!appState.uploadedImage) {
    return 1;
  }

  const img = appState.uploadedImage;
  const imgElement = img._element;
  if (!imgElement) {
    return 1;
  }

  const canvasWidth = appState.selectedWidth;
  const canvasHeight = appState.selectedHeight;
  const W = img.width;
  const H = img.height;

  const scaleX = appState.innerWidth / W;
  const scaleY = appState.innerHeight / H;

  let newScale = Math.max(scaleX, scaleY);
  if (!isFinite(newScale) || newScale <= 0) newScale = 1;

  img.scaleX = newScale;
  img.scaleY = newScale;
  appState.scaleFactor = newScale;

  const centerX = canvasWidth / 2;
  const centerY = canvasHeight / 2;
  const fitScale = Math.max(scaleX, scaleY);
  const finalZoom = Math.min(1, fitScale);

  return finalZoom;
}

function getBaseScale() {
  if (!appState.uploadedImage) return 1;

  const img = appState.uploadedImage;
  const canvasWidth = appState.selectedWidth || canvas.getWidth();
  const canvasHeight = appState.selectedHeight || canvas.getHeight();

  const imgW = img.width || (img._element && img._element.naturalWidth) || 0;
  const imgH = img.height || (img._element && img._element.naturalHeight) || 0;

  if (imgW <= 0 || imgH <= 0 || canvasWidth <= 0 || canvasHeight <= 0) return 1;

  const scaleX = canvasWidth / imgW;
  const scaleY = canvasHeight / imgH;
  const result = Math.min(scaleX, scaleY);

  return isFinite(result) && result > 0 ? result : 1;
}

function updateZoom(newZoom) {
  if (!appState.uploadedImage) {
    console.warn("No uploaded image to zoom");
    return;
  }

  try {
    const baseScale = getBaseScale();
    const requestedZoom = Math.max(appState.minZoom, Math.min(appState.maxZoom, newZoom));
    const dpiMaxZoom = getDynamicMaxZoom();
    newZoom = clampZoomByDpi(requestedZoom, MIN_PRINT_DPI);
    appState.zoom = newZoom;

    if (baseScale <= 0 || !isFinite(baseScale)) {
      console.warn("Invalid base scale for zoom:", baseScale);
      return;
    }

    const finalScale = baseScale * appState.zoom;

    appState.uploadedImage.scaleX = finalScale;
    appState.uploadedImage.scaleY = finalScale;
    appState.scaleFactor = finalScale;

    updateMovementConstraints();
    centerImage();
    appState.uploadedImage.setCoords();
    updatePositionInfo();

    const slider = document.getElementById("zoomSlider");
    if (slider) {
      slider.value = String(Math.round(appState.zoom * 100));
      updateSliderBackground(slider);
    }

    updateZoomLabel();
    updateZoomControlsState();
    canvas.requestRenderAll();

    return {
      requestedZoom,
      appliedZoom: newZoom,
      dpiMaxZoom,
      hitLimit: requestedZoom > (newZoom + 0.000001)
    };
  } catch (error) {
    console.error("Error in updateZoom:", error);
    return {
      requestedZoom: newZoom,
      appliedZoom: appState.zoom,
      dpiMaxZoom: getDynamicMaxZoom(),
      hitLimit: false
    };
  }
}

function updateZoomLabel() {
  const zoomLabel = document.getElementById("zoomLabel");
  if (zoomLabel) {
    zoomLabel.textContent = `${Math.round(appState.zoom * 100)}%`;
  }
}

function syncZoomSlider() {
  const slider = document.getElementById("zoomSlider");
  if (!slider || !appState.uploadedImage) return;

  try {
    // Calculate current zoom based on image scale
    const baseScale = getBaseScale();

    if (baseScale <= 0 || !isFinite(baseScale)) {
      console.warn("Invalid base scale:", baseScale);
      return;
    }

    const currentZoom = appState.uploadedImage.scaleX / baseScale;

    // Update appState.zoom with proper bounds
    appState.zoom = Math.max(
      appState.minZoom,
      Math.min(getDynamicMaxZoom(), currentZoom)
    );

    // Update slider
    slider.min = String(appState.minZoom * 100);
    slider.max = String(Math.round(getDynamicMaxZoom() * 100));
    slider.value = String(Math.round(appState.zoom * 100));

    updateSliderBackground(slider);
    updateZoomLabel();
    updateZoomControlsState();
  } catch (error) {
    console.error("Error in syncZoomSlider:", error);
  }
}

function handleZoomSlider(slider) {
  if (!appState.uploadedImage) return;

  try {
    const zoomValue = Number(slider.value) / 100;
    const result = updateZoom(zoomValue);
    const currentMax = Number(slider.max);
    const isSliderAtMax = Number(slider.value) >= currentMax;
    if ((result && result.hitLimit) || isSliderAtMax) {
      showZoomLimitMessage();
    }
    updateSliderBackground(slider);
  } catch (error) {
    console.error("Error in handleZoomSlider:", error);
  }
}
function setZoomToCover() {
  if (!appState.uploadedImage) return;

  const img = appState.uploadedImage;
  const canvasWidth = appState.selectedWidth;
  const canvasHeight = appState.selectedHeight;

  // Calculate cover scale (fills the frame)
  const scaleX = canvasWidth / img.width;
  const scaleY = canvasHeight / img.height;
  const coverScale = Math.max(scaleX, scaleY);

  // Calculate zoom level based on cover scale
  const baseScale = getBaseScale();
  const coverZoom = coverScale / baseScale;

  // Apply zoom
  updateZoom(coverZoom);
}


function setZoomToFit() {
  if (!appState.uploadedImage) return;

  const img = appState.uploadedImage;
  const canvasWidth = appState.selectedWidth;
  const canvasHeight = appState.selectedHeight;

  // Calculate fit scale (fits within frame)
  const scaleX = canvasWidth / img.width;
  const scaleY = canvasHeight / img.height;
  const fitScale = Math.min(scaleX, scaleY);

  // Calculate zoom level based on fit scale
  const baseScale = getBaseScale();
  const fitZoom = fitScale / baseScale;

  // Apply zoom (100% = fit to frame)
  updateZoom(fitZoom);
}


function zoomIn() {
  if (!appState.uploadedImage) return;

  const newZoom = appState.zoom * 1.1;
  const result = updateZoom(newZoom);
  const atMax = isAtDynamicMaxZoom();
  if ((result && result.hitLimit) || atMax) {
    showZoomLimitMessage();
  }
}

function zoomOut() {
  if (!appState.uploadedImage) return;

  // Decrease zoom by 10%
  const newZoom = appState.zoom * 0.9;
  updateZoom(newZoom);
}

function resetZoom() {
  // Reset to 100% zoom (fit to frame)
  updateZoom(1.0);
}

handleZoomSlider(slider);

slider.addEventListener("input", () => handleZoomSlider(slider));

// zoomInBtn.addEventListener("click", () => updateZoom(appState.zoom + 1));
// zoomOutBtn.addEventListener("click", () => updateZoom(appState.zoom - 1));

// ===========================================
// PINCH TO ZOOM FUNCTIONALITY FOR MOBILE
// ===========================================
// Variables for pinch zoom
let initialDistance = 0;
let initialZoom = 1;
let lastCenter = { x: 0, y: 0 };
let isPinching = false;
let lastTouchTime = 0;

// Function to calculate distance between two touch points
function getTouchDistance(touch1, touch2) {
  const dx = touch2.clientX - touch1.clientX;
  const dy = touch2.clientY - touch1.clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

// Function to calculate center point between two touches
function getTouchCenter(touch1, touch2) {
  return {
    x: (touch1.clientX + touch2.clientX) / 2,
    y: (touch1.clientY + touch2.clientY) / 2
  };
}

// Convert screen coordinates to canvas coordinates
function screenToCanvas(x, y) {
  const canvasRect = canvas.getElement().getBoundingClientRect();
  const zoom = canvas.getZoom();
  return {
    x: (x - canvasRect.left) / zoom,
    y: (y - canvasRect.top) / zoom
  };
}

// Touch start event
canvas.wrapperEl.addEventListener('touchstart', function (e) {
  if (e.touches.length === 2 && appState.uploadedImage) {
    e.preventDefault();
    e.stopPropagation();

    const touch1 = e.touches[0];
    const touch2 = e.touches[1];

    initialDistance = getTouchDistance(touch1, touch2);
    initialZoom = appState.scaleFactor || 1;
    lastCenter = getTouchCenter(touch1, touch2);
    isPinching = true;

    // Store the timestamp to prevent double-tap zoom
    lastTouchTime = Date.now();
  }
}, { passive: false });

// Touch move event
canvas.wrapperEl.addEventListener('touchmove', function (e) {
  if (e.touches.length === 2 && appState.uploadedImage && isPinching) {
    e.preventDefault();
    e.stopPropagation();

    const touch1 = e.touches[0];
    const touch2 = e.touches[1];

    const currentDistance = getTouchDistance(touch1, touch2);
    const currentCenter = getTouchCenter(touch1, touch2);

    // Calculate zoom factor
    const zoomFactor = currentDistance / initialDistance;
    const newScale = initialZoom * zoomFactor;

    // Apply constraints to zoom
    const minScale = 0.01;
    const maxScale = 10;
    const clampedScale = Math.max(minScale, Math.min(maxScale, newScale));
    const baseScale = getBaseScale();
    const requestedPinchZoom = baseScale > 0 ? (clampedScale / baseScale) : appState.zoom;
    const clampedPinchZoom = baseScale > 0 ? clampZoomByDpi(requestedPinchZoom, MIN_PRINT_DPI) : appState.zoom;
    const dpiSafeScale = baseScale > 0 ? baseScale * clampedPinchZoom : clampedScale;

    // Get canvas center in screen coordinates
    const canvasRect = canvas.getElement().getBoundingClientRect();
    const canvasCenterX = canvasRect.left + canvasRect.width / 2;
    const canvasCenterY = canvasRect.top + canvasRect.height / 2;

    // Calculate translation (panning during pinch)
    const deltaX = currentCenter.x - lastCenter.x;
    const deltaY = currentCenter.y - lastCenter.y;

    // Apply zoom with pivot at touch center
    const oldScale = appState.scaleFactor;
    appState.scaleFactor = dpiSafeScale;

    // Calculate the scale change
    const scaleChange = dpiSafeScale / oldScale;

    // Update the image scale
    if (appState.uploadedImage) {
      const img = appState.uploadedImage;

      // Convert touch center to canvas coordinates relative to image
      const canvasCoords = screenToCanvas(lastCenter.x, lastCenter.y);

      // Get current image position and dimensions
      const imgLeft = img.left;
      const imgTop = img.top;
      const imgWidth = img.getScaledWidth();
      const imgHeight = img.getScaledHeight();

      // Calculate new position to keep the pinch center point fixed
      const newLeft = canvasCoords.x - (canvasCoords.x - imgLeft) * scaleChange;
      const newTop = canvasCoords.y - (canvasCoords.y - imgTop) * scaleChange;

      // Apply new scale and position
      img.scaleX = dpiSafeScale;
      img.scaleY = dpiSafeScale;
      img.left = newLeft;
      img.top = newTop;

      // Also apply additional panning from finger movement
      img.left += deltaX / canvas.getZoom();
      img.top += deltaY / canvas.getZoom();

      img.setCoords();
    }

    // Update center for next move
    lastCenter = currentCenter;

    // Update everything
    updateMovementConstraints();
    updatePositionInfo();
    syncZoomSlider();
    if (requestedPinchZoom > (clampedPinchZoom + 0.000001)) {
      showZoomLimitMessage();
    }
    canvas.requestRenderAll();
  } else if (e.touches.length === 1 && appState.uploadedImage && !isPinching) {
    // Allow single finger panning (fabric.js will handle this)
    // We just need to update position info
    requestAnimationFrame(() => {
      updatePositionInfo();
    });
  }
}, { passive: false });

// Touch end event
canvas.wrapperEl.addEventListener('touchend', function (e) {
  if (isPinching) {
    isPinching = false;

    // Reset variables
    initialDistance = 0;
    initialZoom = 1;
    lastCenter = { x: 0, y: 0 };

    // Sync slider with current zoom
    syncZoomSlider();
    canvas.requestRenderAll();
  }

  // Handle double tap for zoom reset
  const currentTime = Date.now();
  const timeDiff = currentTime - lastTouchTime;

  // if (timeDiff < 300 && e.touches.length === 0 && e.changedTouches.length === 1) {
  //   // Double tap detected - reset to fit
  //   if (appState.uploadedImage) {
  //     fitImageToFrame(true);
  //   }
  // }

  lastTouchTime = currentTime;
});

// Prevent default touch actions on canvas
canvas.wrapperEl.style.touchAction = 'none';
canvas.wrapperEl.style.webkitUserSelect = 'none';
canvas.wrapperEl.style.userSelect = 'none';

// Also add touch event listeners to the canvas element itself
canvas.getElement().addEventListener('touchstart', function (e) {
  if (e.touches.length === 2) {
    e.preventDefault();
  }
}, { passive: false });

canvas.getElement().addEventListener('touchmove', function (e) {
  if (e.touches.length === 2) {
    e.preventDefault();
  }
}, { passive: false });

// Add pinch zoom indicator (optional visual feedback)
function showPinchFeedback() {
  const feedback = document.createElement('div');
  feedback.style.cssText = `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0,0,0,0.7);
    color: white;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 14px;
    z-index: 10000;
    pointer-events: none;
    transition: opacity 0.3s;
  `;
  feedback.textContent = 'Pinch to zoom';
  document.body.appendChild(feedback);

  setTimeout(() => {
    feedback.style.opacity = '0';
    setTimeout(() => {
      document.body.removeChild(feedback);
    }, 300);
  }, 1500);
}




window.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const toolParam = params.get("tool");
  const syncmodeparam = params.get("syncMode");

  const firstSelected = document.querySelector("#frameSizeOptions input[name=\"frameSize\"]:checked") || document.querySelector("#frameSizeOptions input[name=\"frameSize\"]");

  if (firstSelected) {
    const [width, height] = firstSelected.getAttribute("data-size").split("x").map(Number);
    appState.selectedWidth = width;
    appState.selectedHeight = height;
    updateFrameFromPixels(appState.selectedWidth, appState.selectedHeight);
  }

  if (syncmodeparam === "select-pdp" || syncmodeparam === "select-print" || syncmodeparam === "pdp-select" || syncmodeparam === "pdp-img" || syncmodeparam === "select-non-pdp") {
    let sessionImageData1;
    let shouldDisableSizes = false;
    let pdpSelectTag;
    if (syncmodeparam === "select-pdp") {
      sessionImageData1 = getLocalStorage1Day("pdp-select-img");
      pdpSelectTag = getLocalStorage1Day("select-tags");
    } else if (syncmodeparam === "select-print") {
      sessionImageData1 = getLocalStorage1Day("select-print-image");
      pdpSelectTag = getLocalStorage1Day("select-tags");
    } else if (syncmodeparam === "pdp-img") {
      sessionImageData1 = getLocalStorage1Day("pdpUploadedImage");
    } else if (syncmodeparam === "pdp-select") {
      sessionImageData1 = getLocalStorage1Day("frame-select-img");
    } else if (syncmodeparam === "select-non-pdp") {
      sessionImageData1 = getLocalStorage1Day("nonuser-image");
      pdpSelectTag = getLocalStorage1Day("select-tags");
    }

    if (pdpSelectTag) {
      try {
        const tags = JSON.parse(pdpSelectTag);
        shouldDisableSizes = tags.includes("style-image") || tags.includes("edit-image");
      } catch (e) {
        console.error(e);
      }
    }

    const disableFrameSizes = [
      '30″×40″',
      '20″×60″',
      '32″×48″',
      '40″×60″',
      '40″×55″',
      '20″×40″',
      '24″×48″',
      '32″×32″',
      '36″×36″',
      '37″×37″'
    ];


    if (shouldDisableSizes) {

      document.querySelectorAll('#frameSizeOptions input[name="frameSize"]').forEach(input => {

        const frameSize = input.getAttribute("data-frmsize");

        if (disableFrameSizes.includes(frameSize)) {

          input.disabled = true;

          const label = input.closest(".frame-size-btn");

          if (label) {
            label.style.pointerEvents = "none";
            label.style.opacity = "0.5";
            label.style.cursor = "not-allowed";
          }

        }

      });

    }
    if (sessionImageData1) {
      showCanvasOpsLoader();
      galleryWrapper.style.display = "none";
      if (galleryWrapperbtn) galleryWrapperbtn.style.display = "none";
      galleryWrappermain.style.gridTemplateRows = "max-content";
      uploadInputwrap.style.display = "none";
      customForm.style.display = "block";

      const mainImgWrap = document.querySelector(".main-img-wrap");
      if (mainImgWrap) {
        mainImgWrap.setAttribute("data-main-img", sessionImageData1);
      }

      const tempImg = new Image();
      tempImg.onload = function () {

        const imgfileWElement = document.getElementById("img-file-w");
        const imgfileHElement = document.getElementById("img-file-h");

        if (imgfileWElement) imgfileWElement.textContent = tempImg.width;
        if (imgfileHElement) imgfileHElement.textContent = tempImg.height;

        fabric.Image.fromURL(sessionImageData1, function (img) {
          appState.uploadedImage = img;
          appState.uploadedImage.set({
            originX: "center",
            originY: "center",
            clipPath: appState.clipPath,
          });
          disableImageSelectionUI(appState.uploadedImage);

          canvas.add(appState.uploadedImage);
          const didAutoSelectOrientation = applyUploadedImageOrientationPreference(appState.uploadedImage);
          setMovementConstraints();
          canvas.setActiveObject(appState.uploadedImage);
          canvas.moveTo(appState.uploadedImage, 2);
          if (!didAutoSelectOrientation) {
            handleOrientationChange();
          }
          syncZoomSlider();
          canvas.requestRenderAll();
          requestAnimationFrame(() => hideCanvasOpsLoader());

          const resetBtn = document.getElementById("resetUploadBtn");
          if (resetBtn) resetBtn.style.display = "";
        });
        document.querySelectorAll(".image-conform-btn").forEach(div => {
          div.style.pointerEvents = "auto";
          div.style.opacity = "1";
        });
      };
      tempImg.onerror = function () {
        hideCanvasOpsLoader();
      };
      tempImg.src = sessionImageData1;
    }
  }
});


document.addEventListener("DOMContentLoaded", function () {
  function updateVariantId() {
    const size = document.querySelector('input[name="frameSize"]:checked')?.value;
    if (!size) return;


    const variant = window.productVariants?.find(
      (v) => v.option1 === size
    );


    if (!variant) {
      console.warn("No variant matched size:", size);
      return;
    }


    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = variant.id;

    const variantInputSize = document.querySelector('input[name="properties[_pdp-size]"]');
    if (variantInputSize) variantInputSize.value = variant.option1;

    const variantInputSku = document.querySelector('input[name="properties[_pdp-variant-id]"]');
    if (variantInputSku) variantInputSku.value = variant.sku;

    const variantInputColor = document.querySelector('input[name="properties[_pdp-color]"]');
    if (variantInputColor) {
      const colorValue = document.querySelector('input[name="frameColor"]:checked')?.value || "";
      variantInputColor.value = colorValue;
    }



    let numericPrice = null;
    let numericCmpPrice = null;
    if (typeof variant.price === "number") {
      numericPrice = variant.price / 100;
    } else if (variant.price?.amount) {
      numericPrice = parseFloat(variant.price.amount);
    } else if (variant.priceV2?.amount) {
      numericPrice = parseFloat(variant.priceV2.amount);
    }

    let finalPrice = numericPrice;
    if (Number.isFinite(numericPrice) && window.isPremiumCustomer === true) {
      finalPrice = numericPrice * 0.9; // 10% OFF
    }


    const priceElement = document.querySelector("#price-sale-text");
    if (priceElement) {
      priceElement.textContent = Number.isFinite(finalPrice)
        ? `$${finalPrice.toFixed(2)}`
        : "";
    }

    const priceElement1 = document.querySelector(".main-price");
    if (priceElement1) {
      priceElement1.textContent = Number.isFinite(finalPrice)
        ? `$${finalPrice.toFixed(2)}`
        : "";
    }

    if (typeof variant.compare_at_price === "number") {
      numericCmpPrice = variant.compare_at_price / 100;
    } else if (variant.compare_at_price?.amount) {
      numericCmpPrice = parseFloat(variant.compare_at_price.amount);
    } else if (variant.compare_at_priceV2?.amount) {
      numericCmpPrice = parseFloat(variant.compare_at_priceV2.amount);
    }

    const cmppriceElement = document.querySelector("#compare-price-text");
    if (cmppriceElement) {
      cmppriceElement.textContent = Number.isFinite(numericCmpPrice)
        ? `$${numericCmpPrice.toFixed(2)}`
        : "";
    }
    const cmppriceElement1 = document.querySelector(".compare-price");
    if (cmppriceElement1) {
      cmppriceElement1.textContent = Number.isFinite(numericCmpPrice)
        ? `$${numericCmpPrice.toFixed(2)}`
        : "";
    }

    const savePrElement = document.querySelector("#save-pr-text");
    if (savePrElement) {
      if (
        Number.isFinite(finalPrice) &&
        Number.isFinite(numericCmpPrice) &&
        numericCmpPrice > finalPrice
      ) {
        const discountPercent = Math.round(
          ((numericCmpPrice - finalPrice) / numericCmpPrice) * 100
        );
        savePrElement.textContent = `${discountPercent}%`;
        savePrElement.style.display = "";
      } else {
        savePrElement.textContent = "";
        savePrElement.style.display = "none";
      }
    }
    const savePrElement1 = document.querySelector(".save-percentage");
    if (savePrElement1) {
      if (
        Number.isFinite(finalPrice) &&
        Number.isFinite(numericCmpPrice) &&
        numericCmpPrice > finalPrice
      ) {
        const discountPercent = Math.round(
          ((numericCmpPrice - finalPrice) / numericCmpPrice) * 100
        );
        savePrElement1.textContent = `Save ${discountPercent}%`;
        savePrElement1.style.display = "";
      } else {
        savePrElement1.textContent = "";
        savePrElement1.style.display = "none";
      }
    }


    const productImage = document.querySelector(".image-magnify-lightbox");
    if (productImage && variant.image) {
      const imageUrl =
        typeof variant.image === "string"
          ? variant.image
          : variant.image.src;

      productImage.src = imageUrl;

      const widths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
      productImage.srcset = widths
        .map((w) => `${imageUrl}?width=${w} ${w}w`)
        .join(", ");

      productImage.alt = variant.image.alt || variant.option1;
    }

    if (typeof logAllAddedElements === "function") {
      logAllAddedElements();
    }
  }

  document
    .querySelectorAll('input[name="frameSize"], input[name="frameColor"]')
    .forEach((input) => {
      input.addEventListener("change", (e) => {
        updateVariantId();
        if (typeof scrollToPreviewOnMobile === 'function') {
          scrollToPreviewOnMobile();
        }
      });
    });

  updateVariantId();
});


function submitCartForm(btn) {
  // Refresh size/color/variant-id properties right before submit
  const selectedSize = document.querySelector('input[name="frameSize"]:checked')?.value || "";
  const selectedColor = document.querySelector('input[name="frameColor"]:checked')?.value || "";
  const selectedVariant = window.productVariants?.find((v) => v.option1 === selectedSize);

  const sizeInput = document.querySelector('input[name="properties[_pdp-size]"]');
  if (sizeInput) sizeInput.value = selectedSize;

  const colorInput = document.querySelector('input[name="properties[_pdp-color]"]');
  if (colorInput) colorInput.value = selectedColor;

  const variantIdInput = document.querySelector('input[name="properties[_pdp-variant-id]"]');
  if (variantIdInput && selectedVariant) variantIdInput.value = selectedVariant.sku || selectedVariant.id;

  const checkedWrap = document.querySelector('input[name="wrap_type"]:checked');
  const wrapValue = normalizeWrapValue(checkedWrap ? checkedWrap.value : sessionStorage.getItem("selectedWrap"));
  const checkedSize = document.querySelector('input[name="frameSize"]:checked');
  const sideDepth = checkedSize ? checkedSize.getAttribute('data-side-depth') : '';

  const sideTypeMap = { mirrorwrap: 'mirror', blurwrap: 'mirror-blur', fit: 'fill-to-canvas' };
  const sideType =  'poster';

  const sideTypeInput = document.querySelector('input[name="properties[_pdp-side-type]"]');
  if (sideTypeInput) sideTypeInput.value = sideType;

  const sideInput = document.querySelector('input[name="properties[_pdp-side]"]');
  if (sideInput) sideInput.value = sideDepth;

  const customForm = document.getElementById("custom-image-form");
  if (!customForm) return;

  const currentParams = new URLSearchParams(window.location.search);
  const redirectParams = new URLSearchParams();
  currentParams.forEach((value, key) => { redirectParams.set(key, value); });
  const returnUrl = "/cart" + (redirectParams.toString() ? "?" + redirectParams.toString() : "");
  customForm.action = "/cart/add?return_to=" + encodeURIComponent(returnUrl);

  const productId = document.querySelector('#custom-image-form input[name="id"]')?.value;
  const productTitle = document.querySelector(".product__title")?.innerText || document.title;

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      currency: Shopify?.currency?.active || "USD",
      items: [{ item_id: productId, item_name: productTitle, quantity: 1 }]
    }
  });

  if (btn) btn.textContent = "Added!";
  customForm.submit();
}

document.querySelectorAll(".image-conform-btn").forEach(btn => {
  btn.addEventListener("click", function (e) {
    sendMainImageToAPI(e);
  });
});

async function sendMainImageToAPI(e) {

  const finalpopup = document.querySelector(".finalize-image-popup");
  if (finalpopup) finalpopup.style.display = "none";

  const finalpopup1 = document.querySelector("#is-first");
  if (finalpopup1) finalpopup1.style.display = "none";

  const finalpopup2 = document.querySelector("#is-second");
  if (finalpopup2) finalpopup2.style.display = "none";

  const btn = e.currentTarget;
  btn.textContent = "Adding...";
  btn.disabled = true;

  try {
    {

      const mainImgWrap = document.querySelector(".main-img-wrap");
      if (!mainImgWrap) throw new Error("No .main-img-wrap element found");

      const imageData = mainImgWrap.getAttribute("data-main-img");
      if (!imageData) throw new Error("No image data found");

      function base64ToBlob(base64) {
        const byteString = atob(base64.split(",")[1]);
        const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
        return new Blob([ab], { type: mimeString });
      }

      const formData = new FormData();
      const userId = window.shopifyCustomerId || "guest";
      const sessionId = getLocalStorage1Day("sessionId") || "none";

      if (imageData.startsWith("http") || imageData.startsWith("//")) {
        formData.append("imageUrl", imageData);
      } else if (imageData.startsWith("data:image/")) {
        const imageBlob = base64ToBlob(imageData);
        formData.append("file", imageBlob, "uploaded-image.jpeg");
      } else {
        throw new Error("Invalid image data format");
      }

      formData.append("customerId", userId);
      formData.append("sessionId", sessionId);

      const response = await fetch(`${window.Prompt2Prints.apiBase}/upload-image`, {
        method: "POST",
        headers: {
          "x-api-key": window.Prompt2Prints.apiKey
        },
        body: formData,
      });
      const data = await response.json();

      const imageUpscale = document.querySelector('input[name="properties[_pdp-allow-upscale]"]');
      const imageUpscaletag = document.querySelector('input[name="properties[_pdp-img-tag]"]');

      if (!imageUpscale || !imageUpscaletag) {
        console.warn("Upscale inputs not found");
        return;
      }

      const flag = (data.flag || "").toLowerCase();

      if (flag === "standard") {
        imageUpscale.value = "true";
        imageUpscaletag.value = "Standard";
      }
      else if (flag === "professional") {
        imageUpscale.value = "false";
        imageUpscaletag.value = "Professional";
      }
      else {
        imageUpscale.value = "";
        imageUpscaletag.value = "";
      }

      // Optional: also update attribute for Shopify forms
      imageUpscale.setAttribute("value", imageUpscale.value);
      imageUpscaletag.setAttribute("value", imageUpscaletag.value);

      const cvswElement = parseFloat(document.getElementById("cvs-w")?.textContent) || 0;
      const cvswFinalElement = appState.finalw || 0;
      const cvshFinalElement = appState.finalh || 0;
      const cvstElement = appState.finalt || 0;
      const cvslElement = appState.finall || 0;
      const cvshElement = parseFloat(document.getElementById("cvs-h")?.textContent) || 0;
      const hiddenimg = document.getElementById("frame-img-position");
      const orientationRadio = document.querySelector('input[name="orientation"]:checked');
      const orientation = orientationRadio ? orientationRadio.value : "portrait";
      if (orientation == "portrait") {
        if (hiddenimg) {
          hiddenimg.value = JSON.stringify({
            area_width: cvswElement,
            area_height: cvshElement,
            width: cvswFinalElement,
            height: cvshFinalElement,
            top: cvstElement,
            left: cvslElement,
          });
        }
      }
      else if (orientation == "landscape") {
        if (hiddenimg) {
          hiddenimg.value = JSON.stringify({
            area_width: cvswElement,
            area_height: cvshElement,
            width: cvswFinalElement,
            height: cvshFinalElement,
            top: cvstElement,
            left: cvslElement,
          });
        }
      }
      const hiddenInput = document.getElementById("final-image-data");
      if (hiddenInput) {
        hiddenInput.value = localStorage.getItem("pdpUploadedImage") || data.cloudfrontLink;
      }

      await exportFullDivAsImage(userId, sessionId);

      // These will only run after exportFullDivAsImage is completely finished
      if (finalpopup1) finalpopup1.style.display = "none";
      if (finalpopup2) finalpopup2.style.display = "none";

      submitCartForm(btn);
    }
  } catch (error) {
    console.error("ERROR in sendMainImageToAPI:", error);
    btn.textContent = "Failed. Try again";
  } finally {
    btn.disabled = false;
  }
}
async function urlToBase64(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "https://prompt2prints.com";
    img.onload = () => {
      const canvasEl = document.createElement("canvas");
      canvasEl.width = img.width;
      canvasEl.height = img.height;
      const ctx = canvasEl.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvasEl.toDataURL("image/jpeg"));
    };
    img.onerror = reject;
    img.src = url;
  });
}

window.addedElements = [];

window.logAllAddedElements = function () {
  window.addedElements.forEach((el, index) => {
    // Log elements if needed
  });
};

window.removeSelectedElements = function (indices) {
  indices.sort((a, b) => b - a);

  indices.forEach((i) => {
    if (window.addedElements[i]) {
      canvas.remove(window.addedElements[i]);
      window.addedElements.splice(i, 1);
    }
  });
};


async function reloadImageAsBase64(img) {

  const src = img._element.src;
  const left = img.left;
  const top = img.top;
  const scaleX = img.scaleX;
  const scaleY = img.scaleY;
  const angle = img.angle;
  const originX = img.originX;
  const originY = img.originY;

  const base64 = await urlToBase64(src);

  return new Promise((resolve) => {
    fabric.Image.fromURL(base64, (newImg) => {
      newImg.set({ left, top, scaleX, scaleY, angle, originX, originY });

      // 🔴 REMOVE CENTER GUIDE LINES
      canvas.getObjects('line').forEach((obj) => {
        if (obj.stroke === 'red' && obj.opacity === 0.5) {
          canvas.remove(obj);
        }
        else if (obj.name === 'centerLine') {
          canvas.remove(obj);
        }
      });

      canvas.remove(img);
      canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));

      canvas.add(newImg);
      window.addedElements.push(newImg);

      // ---------------- INNER PADDING LOGIC ----------------
      let innerPadding = 0;
      const size = `${appState.originalWidth}x${appState.originalHeight}`;

      const borderSize = innerPadding;

      const frmcolor1 = "rgba(0, 0, 0, 0.4)";
      // Existing border
      const border = new fabric.Rect({
        top: 0,
        left: 0,
        width: appState.selectedWidth - borderSize,
        height: appState.selectedHeight - borderSize,
        fill: 'transparent',
        stroke: frmcolor1,
        strokeWidth: borderSize,
        selectable: false,
        evented: false
      });

      canvas.add(border);
      canvas.bringToFront(border);
      window.addedElements.push(border);

      // ----------------- ADD DOTTED LINE INSIDE -----------------
      const dotPadding = borderSize; // distance from border
      const dottedBorder = new fabric.Rect({
        top: dotPadding,
        left: dotPadding,
        width: appState.selectedWidth - (borderSize * 2) - 1,
        height: appState.selectedHeight - (borderSize * 2) - 1,
        fill: 'transparent',
        stroke: 'rgba(0,0,0,0.4)', // you can change color
        strokeWidth: 1,
        selectable: false,
        evented: false,
        strokeDashArray: [5, 5] // 5px line, 5px gap
      });

      canvas.add(dottedBorder);
      canvas.bringToFront(dottedBorder);
      window.addedElements.push(dottedBorder);
      resolve(newImg);
      logAllAddedElements();

    }, { crossOrigin: "anonymous" });
  });
}



async function exportFullDivAsImage(customerId, sessionId) {
  const parentDiv = document.querySelector(".back-image");
  if (!parentDiv) {
    console.error("No element with class .back-image found");
    return;
  }

  if (typeof canvas === "undefined") {
    console.error("Fabric.js canvas not defined");
    return;
  }

  canvas.discardActiveObject();
  canvas.getObjects().forEach(obj => obj.set({
    selectable: false,
    evented: false
  }));

  canvas.renderAll();

  try {
    const images = canvas.getObjects("image");
    await Promise.all(images.map(img => reloadImageAsBase64(img)));


    // 1️⃣ Export canvas to data URL
    const dataURL = canvas.toDataURL({
      format: "jpeg",
      multiplier: 2,
    });
    // const paddedDataURL = await addPaddingToDataURL(dataURL, 0);

    const res = await fetch(dataURL);
    const blob = await res.blob();

    const formData = new FormData();
    formData.append("file", blob, "full-div-image.jpeg");
    formData.append("customerId", customerId);
    formData.append("sessionId", sessionId);
    formData.append("thumbnailWidth", "200");

    const response = await fetch(`${window.Prompt2Prints.apiBase}/image-thumbnail`, {
      method: "POST",
      headers: {
        "x-api-key": window.Prompt2Prints.apiKey
      },
      body: formData,
    });

    const data = await response.json();

    const hiddenInput = document.getElementById("preview-image-data");
    if (hiddenInput && data.original?.cloudfrontUrl) hiddenInput.value = data.original.cloudfrontUrl;

    const hiddenInput1 = document.getElementById("preview-thumb-image-data");
    if (hiddenInput1 && data.thumbnail?.cloudfrontUrl) hiddenInput1.value = data.thumbnail.cloudfrontUrl;

    // Optional: display padded image in .full-content
    let fullContentDiv = document.querySelector(".full-content");
    if (!fullContentDiv) {
      fullContentDiv = document.createElement("div");
      fullContentDiv.className = "full-content";
      document.body.appendChild(fullContentDiv);
    }
    fullContentDiv.innerHTML = "";
    const imgElement = document.createElement("img");
    imgElement.src = dataURL;
    fullContentDiv.appendChild(imgElement);
    removeSelectedElements([1, 2, 3]);

  } catch (err) {
    console.error("Error exporting full div:", err);
  } finally {
    canvas.getObjects().forEach(obj => {
      obj.set({
        selectable: true,
        evented: true
      });
      if (obj.type === "image") disableImageSelectionUI(obj);
    });
    canvas.renderAll();
  }
}

// Helper function: add padding to a dataURL
function addPaddingToDataURL(dataURL, padding) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = dataURL;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width + padding * 2;
      canvas.height = img.height + padding * 2;
      const ctx = canvas.getContext("2d");

      ctx.fillStyle = "#000000";

      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw original image in center
      ctx.drawImage(img, padding, padding);

      resolve(canvas.toDataURL("image/jpeg"));
    };
  });
}


function captureImageTransform(image) {
  if (!image) return null;

  return {
    left: image.left,
    top: image.top,
    angle: image.angle,
    originX: image.originX || "left",
    originY: image.originY || "top",

    // ✅ visible size in canvas px
    visibleWidth: image.getScaledWidth(),
    visibleHeight: image.getScaledHeight()
  };
}


function applyImageTransform(image, transform) {
  if (!image || !transform) return;

  const scaleX = transform.visibleWidth / image.width;
  const scaleY = transform.visibleHeight / image.height;

  image.set({
    left: transform.left,
    top: transform.top,
    angle: transform.angle,
    originX: transform.originX,
    originY: transform.originY,
    scaleX,
    scaleY
  });

  image.setCoords();
}


async function upscaleAndFixDPI({
  sessionId = "none",
  customerId = "guest",
  dpi = null,
  printHeight = null,
  printWidth = null,
  imageUrl = null,
  file = null,
  callback = null
}) {

  const savepopup = document.querySelector(".save-image-popup");
  const afterSavePopup = document.querySelector("#aftersavepopup");

  if (savepopup) savepopup.style.display = "flex";
  if (afterSavePopup) afterSavePopup.style.display = "none";

  const savepopuptitle = document.querySelector(".save-image-title");
  const savepopupicon = document.querySelector(".save-image-icon");
  const savepopuptext = document.querySelector(".save-image-text");

  savepopuptitle.textContent = "Boosting Image";
  savepopuptext.textContent = "Boosting resolution for maximum clarity";
  if (savepopupicon) savepopupicon.style.display = "flex";

  // 🔹 SAVE CURRENT IMAGE TRANSFORM
  const previousTransform = captureImageTransform(appState.uploadedImage);

  const imagefinalWidth = (appState.imageWidth * 300) / appState.dpi;
  const imagefinalHeight = (appState.imageheight * 300) / appState.dpi;

  const imagesize = appState.uploadimgsize;
  const formData = new FormData();
  formData.append("sessionId", sessionId);
  formData.append("customerId", customerId);
  if (dpi) formData.append("dpi", dpi);
  if (printWidth) formData.append("printWidth", printWidth);
  if (printHeight) formData.append("printHeight", printHeight);
  formData.append("format", "jpeg");
  formData.append("faceEnhancement", "true");
  formData.append("finalWidth", imagefinalWidth);
  formData.append("finalHeight", imagefinalHeight);
  const currentPageUrl = window.location.href;
  formData.append("page_url", currentPageUrl);
  if (imageUrl) {
    formData.append("imageUrl", imageUrl);
  }

  if (file) {
    formData.append("file", file);
    formData.append("isDirectUpload", "true");
    formData.append("inputImageSizeMB", imagesize);
  }

  try {
    const response = await fetch(`${window.Prompt2Prints.apiBase}/boost-image`, {
      method: "POST",
      headers: {
        "x-api-key": window.Prompt2Prints.apiKey
      },
      body: formData
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    const result = await response.json();
    if (result?.error) {
      throw new Error(result.error);
    }

    const enhancedUrl = result?.enhanced;
    if (!enhancedUrl) {
      throw new Error("No enhanced URL returned");
    }

    const mainImgWrap = document.querySelector(".main-img-wrap");
    if (mainImgWrap) {
      mainImgWrap.setAttribute("data-main-img", enhancedUrl);
      mainImgWrap.innerHTML = `<img src="${enhancedUrl}" style="max-width:100%;">`;
    }

    fabric.Image.fromURL(enhancedUrl, async (img) => {

      // 🔹 CLEAR CANVAS SAFELY
      canvas.clear();
      canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));

      appState.uploadedImage = img;
      appState.uploadedImage.set({
        originX: "center",
        originY: "center",
        clipPath: appState.clipPath || null
      });
      disableImageSelectionUI(appState.uploadedImage);

      canvas.add(appState.uploadedImage);

      // 🔹 RESTORE EXACT SAME POSITION
      if (previousTransform) {
        applyImageTransform(appState.uploadedImage, previousTransform);
      } else {
        canvas.centerObject(appState.uploadedImage);
      }

      setMovementConstraints();
      canvas.setActiveObject(appState.uploadedImage);
      canvas.renderAll();

      // fitImageToFrame(true);

      document.getElementById("img-file-w").textContent =
        appState.uploadedImage.width || 0;
      document.getElementById("img-file-h").textContent =
        appState.uploadedImage.height || 0;

      await updatePositionInfo();
      syncZoomSlider();

      // 🔹 KEEP WRAP TYPE
      // const value = sessionStorage.getItem("selectedWrap");
      // if (value === "black") coverFrame("black");
      // if (value === "white") coverFrame("white");
      // if (value === "fit") fitImageToFrame(true);

      // 🔹 DPI UI
      //  const dpiElement = document.querySelector(".dpi-num");
      // const iconElement = document.querySelector(".dpi-state-icon");
      const boostBtn = document.querySelector(".boost-img-btn");
      const currentDpi = Number((appState.dpi || 0).toFixed(2));

      if (boostBtn) {

        iconElement.innerHTML = ""; // clear old icon

        if (currentDpi < 30) {
          //          dpiElement.textContent = `Needs Upscale`;
          //           dpiElement.style.color = "red";

          //           iconElement.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          // <path d="M9.9891 0C4.49317 0 0 4.49317 0 9.9891C0 15.4859 4.49317 20 9.9891 20C15.485 20 20 15.5068 20 9.9891C20 4.47115 15.5068 0 9.9891 0ZM9.9891 18.3208C5.40912 18.3208 1.67946 14.5911 1.67946 10.0111C1.67946 5.43115 5.40912 1.70148 9.9891 1.70148C14.5691 1.70148 18.2987 5.43115 18.2987 10.0111C18.3207 14.5911 14.5909 18.3208 9.9891 18.3208Z" fill="#FF0606"/>
          // <path d="M10.1207 4.56252C9.74952 4.56252 9.44421 4.69326 9.20466 4.93365C8.98621 5.1732 8.85547 5.52239 8.85547 5.93651C8.85547 6.24185 8.8774 6.72177 8.92126 7.41931L9.16081 10.9307C9.20466 11.4106 9.29154 11.7379 9.37926 11.9774C9.48806 12.2389 9.70651 12.3696 10.0118 12.3696C10.3172 12.3696 10.5137 12.2389 10.6444 11.9774C10.7532 11.7379 10.841 11.3887 10.8629 10.9526L11.1682 7.33156C11.2121 7.0043 11.2121 6.65511 11.2121 6.34977C11.2121 5.78297 11.1463 5.34691 10.9936 5.04073C10.884 4.7371 10.5787 4.56252 10.1207 4.56252Z" fill="#FF0606"/>
          // <path d="M10.0549 13.4844C9.72761 13.4844 9.44421 13.5932 9.20466 13.8336C8.96511 14.0731 8.85547 14.3354 8.85547 14.6627C8.85547 15.0338 8.9862 15.3391 9.2266 15.5348C9.46615 15.7313 9.75039 15.8402 10.0768 15.8402C10.3821 15.8402 10.6655 15.7313 10.9059 15.5129C11.1455 15.2944 11.277 14.6408 11.277 14.6408C11.277 14.3135 11.1682 14.0301 10.9278 13.7906C10.6655 13.5932 10.3813 13.4844 10.0549 13.4844Z" fill="#FF0606"/>
          // </svg>`;

          boostBtn.style.display = "flex";
          boostBtn.classList.add("show")

        } else {
          //          dpiElement.textContent = `Good To Print`;
          //           dpiElement.style.color = "green";

          //           iconElement.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          // <path d="M10 0C4.48421 0 0 4.48421 0 10C0 15.5158 4.48421 20 10 20C15.5158 20 20 15.5158 20 10C20 4.48421 15.5158 0 10 0ZM10 17.8105C5.68421 17.8105 2.18947 14.2947 2.18947 10C2.18947 5.70526 5.68421 2.18947 10 2.18947C14.3158 2.18947 17.8105 5.68421 17.8105 10C17.8105 14.3158 14.3158 17.8105 10 17.8105Z" fill="#1B8600"/>
          // <path d="M12.7139 6.92258L8.90337 10.7542L7.28232 9.13311C6.86127 8.71205 6.16653 8.71205 5.74548 9.13311C5.32442 9.55416 5.32442 10.2489 5.74548 10.6699L8.14548 13.0699C8.356 13.2805 8.62969 13.3857 8.92443 13.3857C9.21916 13.3857 9.49285 13.2805 9.70337 13.0699L14.2928 8.48047C14.7139 8.05942 14.7139 7.36469 14.2928 6.94363C13.8507 6.50153 13.156 6.50153 12.7139 6.92258Z" fill="#1B8600"/>
          // </svg>`;

          boostBtn.classList.remove("show");
          if (!boostBtn.classList.contains("show")) boostBtn.style.display = "none";

        }
      }
    });

    if (
      result?.message ===
      "We can not upscale this image further. Please try a different image."
    ) {
      console.log(result.message);
      if (savepopup) savepopup.style.display = "flex";
      const savepopuptitle = document.querySelector(".save-image-title");
      const savepopupicon = document.querySelector(".save-image-icon");
      const savepopuptext = document.querySelector(".save-image-text");
      const boostBtns = document.querySelectorAll(".boost-img-btn");

      boostBtns.forEach(btn => {
        btn.classList.add("limit-reached");
      });
      if (savepopupicon) savepopupicon.style.display = "none";

      if (result?.message === "We can not upscale this image further. Please try a different image.") {
        savepopuptitle.textContent = "Change Image";
        savepopuptext.textContent =
          "The image has reached its maximum resolution and cannot be upscaled further.";
      }

      setTimeout(() => {
        if (savepopup) savepopup.style.display = "none";
      }, 3000);
    } else {
      // Show aftersave popup and hide savepopup after delay
      if (savepopup) savepopup.style.display = "none";

      if (afterSavePopup) {
        afterSavePopup.style.display = "flex";

        // Hide aftersave popup after 3-4 seconds
        setTimeout(() => {
          afterSavePopup.style.display = "none";
        }, 3500); // 3.5 seconds
      }
    }


  } catch (err) {
    console.error("Upscale API failed:", err);
    if (savepopup) savepopup.style.display = "flex";

    const savepopuptitle = document.querySelector(".save-image-title");
    const savepopupicon = document.querySelector(".save-image-icon");
    const savepopuptext = document.querySelector(".save-image-text");

    if (savepopupicon) savepopupicon.style.display = "none";

    if (err.message === "We can not upscale this image further. Please try a different image.") {
      savepopuptitle.textContent = "Change Image";
      savepopuptext.textContent =
        "The image has reached its maximum resolution and cannot be upscaled further.";
    } else {
      savepopuptitle.textContent = "Upscale Failed";
      savepopuptext.textContent =
        "There was an issue while upscaling the image. Please try again.";
    }

    // Hide popup after 3 seconds
    setTimeout(() => {
      if (savepopup) savepopup.style.display = "none";
    }, 3000);
  }
}

function base64ToFile(base64, filename = "image.jpeg") {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

// // Boost Button event
// document.querySelector(".boost-img-btn").addEventListener("click", (e) => {

//   // ✅ Continue normal flow
//   const userId = window.shopifyCustomerId || "guest";
//   const sessionId = getLocalStorage1Day("sessionId") || "none";

//   const mainImgWrap = document.querySelector(".main-img-wrap");
//   if (!mainImgWrap) {
//     console.error("No .main-img-wrap found.");
//     return;
//   }

//   const dpidata = appState.dpi || 0;
//   const printHeightdata = appState.printimghight || 0;
//   const printWidthdata = appState.printimgwidth || 0;

//   const dataMainImg = mainImgWrap.getAttribute("data-main-img");
//   if (!dataMainImg) {
//     console.error("No data-main-img found.");
//     return;
//   }

//   if (dataMainImg.startsWith("http")) {
//     upscaleAndFixDPI({
//       customerId: userId,
//       sessionId: sessionId,
//       dpi: dpidata,
//       printWidth: printWidthdata,
//       printHeight: printHeightdata,
//       imageUrl: dataMainImg
//     });
//   }
//   else if (dataMainImg.startsWith("data:image")) {
//     const file = base64ToFile(dataMainImg, "uploaded.jpeg");
//     upscaleAndFixDPI({
//       customerId: userId,
//       sessionId: sessionId,
//       dpi: dpidata,
//       printWidth: printWidthdata,
//       printHeight: printHeightdata,
//       file: file
//     });
//   }
//   else {
//     console.error("Invalid data-main-img format.");
//   }
// });

function getCroppedCanvas() {
  let innerPadding = 0;

  const frnheight = appState.orgHeight;
  const frmwidth = appState.orgWidth;
  let size = `${frmwidth}x${frnheight}`;


  const sw = canvas.width - innerPadding * 2;
  const sh = canvas.height - innerPadding * 2;

  mockupState.croppedWidth = sw;
  mockupState.croppedHeight = sh;

  const cropped = document.createElement("canvas");
  cropped.width = sw;
  cropped.height = sh;
  const ctx = cropped.getContext("2d");

  ctx.drawImage(
    canvas.lowerCanvasEl,
    innerPadding, innerPadding, sw, sh,
    0, 0, sw, sh
  );

  return cropped;
}

// Function to insert cropped image into mockups
function insertIntoMockups() {
  const croppedCanvas = getCroppedCanvas();
  const mockupCanvases = document.querySelectorAll(".mockup-canvas");

  mockupCanvases.forEach((mockupCanvas, index) => {
    const ctx = mockupCanvas.getContext("2d");
    ctx.clearRect(0, 0, mockupCanvas.width, mockupCanvas.height);

    const { x, y, w, h } = mockupPlacements[index];

    ctx.drawImage(
      croppedCanvas,
      mockupCanvas.width * x,
      mockupCanvas.height * y,
      mockupCanvas.width * w,
      mockupCanvas.height * h
    );
  });
}

document.getElementById("insertBtn")?.addEventListener("click", insertIntoMockups);

document.addEventListener("DOMContentLoaded", () => {
  const currentUrl = window.location.pathname;
  const links = document.querySelectorAll(".pdp-tab-wrap .pill");

  links.forEach(link => {
    if (link.getAttribute("href") === currentUrl) {
      link.classList.add("active");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const frameSizeSectionNew = document.getElementById("frameSizeOptions");
  const primaryGridNew = frameSizeSectionNew?.querySelector("[data-frame-size-primary]");
  const overflowWrapNew = frameSizeSectionNew?.querySelector("[data-frame-size-see-more]");
  const overflowGridNew = frameSizeSectionNew?.querySelector("[data-frame-size-overflow]");
  const overflowToggleNew = frameSizeSectionNew?.querySelector("[data-frame-size-see-more-toggle]");
  const overflowToggleLabelNew = frameSizeSectionNew?.querySelector("[data-frame-size-see-more-label]");
  const sizeOptionInputsNew = Array.from(
    frameSizeSectionNew?.querySelectorAll('label.frame-size-btn input[name="frameSize"]') || []
  );

  if (frameSizeSectionNew && primaryGridNew && overflowWrapNew && overflowGridNew && overflowToggleNew) {
    let sizeOverflowUserToggledNew = false;
    let sizeAutoSelectionLockedByUserNew = false;
    let isAutoSelectingRecommendedSizeNew = false;
    let lastRecommendationContextKeyNew = "";

    sizeOptionInputsNew.forEach((input, index) => {
      const label = input.closest("label.frame-size-btn");
      if (label && !label.dataset.sizeOrder) {
        label.dataset.sizeOrder = String(index);
      }
    });

    const relatedOptionsMapNew = {
      "9x12": ["18x26", "20x28", "28x40", "40x55"],
      "12x16": ["18x26", "20x28", "28x40", "40x55"],
      "18x24": ["18x26", "20x28", "28x40", "40x55"],
      "24x32": ["18x26", "20x28", "28x40", "40x55"],
      "30x40": ["18x26", "20x28", "28x40", "40x55"],
      "8x12": ["26x40"],
      "12x18": ["26x40"],
      "16x24": ["26x40"],
      "20x30": ["26x40"],
      "24x36": ["26x40"],
      "32x48": ["26x40"],
      "40x60": ["26x40"],
      "8x10": ["11x14", "20x24"],
      "16x20": ["11x14", "20x24"],
      "24x30": ["11x14", "20x24"],
    };

    const normalizeFrameSizeValueNew = (value) => {
      const numberParts = String(value || "").match(/\d+(?:\.\d+)?/g);
      if (!numberParts || numberParts.length < 2) {
        return String(value || "").trim().toLowerCase();
      }
      return `${numberParts[0]}x${numberParts[1]}`;
    };

    const getOrderedSizeLabelsNew = () => (
      Array.from(frameSizeSectionNew.querySelectorAll("label.frame-size-btn"))
        .sort((a, b) => Number(a.dataset.sizeOrder || 0) - Number(b.dataset.sizeOrder || 0))
    );

    const updateOverflowToggleTextNew = (expanded) => {
      overflowToggleNew.setAttribute("aria-expanded", expanded ? "true" : "false");
      if (overflowToggleLabelNew) {
        overflowToggleLabelNew.textContent = expanded ? "Hide extra sizes" : "See more sizes";
      }
    };

    const getRecommendationContextKeyNew = (ratioValue) => {
      const mainImageSource =
        document.querySelector(".main-img-wrap")?.getAttribute("data-main-img") ||
        appState.uploadedImage?._originalElement?.currentSrc ||
        appState.uploadedImage?._originalElement?.src ||
        appState.uploadedImage?._element?.currentSrc ||
        appState.uploadedImage?._element?.src ||
        "";
      const imageWidth = document.getElementById("img-file-w")?.textContent?.trim() || "";
      const imageHeight = document.getElementById("img-file-h")?.textContent?.trim() || "";

      return [ratioValue || "", imageWidth, imageHeight, mainImageSource].join("|");
    };

    const setOverflowExpandedNew = (expanded) => {
      frameSizeSectionNew.classList.toggle("show-size-overflow", expanded);
      overflowGridNew.hidden = !expanded;
      updateOverflowToggleTextNew(expanded);
    };

    const clearSizeRecommendationStateNew = () => {
      getOrderedSizeLabelsNew().forEach((label) => {
        label.dataset.sizeRecommendation = "";
        const input = label.querySelector('input[name="frameSize"]');
        if (input) {
          input.dataset.sizeRecommendation = "";
        }
        const pill = label.querySelector("span");
        if (pill) {
          pill.style.border = "";
        }
      });
    };

    const markSizeRecommendationNew = (input, recommendationType, borderColor) => {
      const label = input.closest("label.frame-size-btn");
      const pill = label?.querySelector("span");
      if (!label || !pill) return;

      if (label.dataset.sizeRecommendation === "recommended" && recommendationType !== "recommended") {
        return;
      }

      label.dataset.sizeRecommendation = recommendationType;
      input.dataset.sizeRecommendation = recommendationType;
      // pill.style.border = `1px solid ${borderColor}`;
    };

    const restoreAllSizeOptionsNew = () => {
      getOrderedSizeLabelsNew().forEach((label) => {
        primaryGridNew.appendChild(label);
      });

      sizeOverflowUserToggledNew = false;
      overflowWrapNew.hidden = true;
      frameSizeSectionNew.classList.remove("has-size-overflow");
      setOverflowExpandedNew(false);
    };

    const applyRecommendedSizeVisibilityNew = () => {
      const orderedLabels = getOrderedSizeLabelsNew();
      const recommendedLabels = orderedLabels.filter(
        (label) => label.dataset.sizeRecommendation === "recommended"
      );

      if (!appState.uploadedImage || !recommendedLabels.length) {
        restoreAllSizeOptionsNew();
        return;
      }

      recommendedLabels.forEach((label) => {
        primaryGridNew.appendChild(label);
      });

      orderedLabels
        .filter((label) => label.dataset.sizeRecommendation !== "recommended")
        .forEach((label) => {
          overflowGridNew.appendChild(label);
        });

      const hasOverflow = overflowGridNew.children.length > 0;
      const selectedLabel = frameSizeSectionNew
        .querySelector('input[name="frameSize"]:checked')
        ?.closest("label.frame-size-btn");

      frameSizeSectionNew.classList.toggle("has-size-overflow", hasOverflow);
      overflowWrapNew.hidden = !hasOverflow;

      if (!hasOverflow) {
        sizeOverflowUserToggledNew = false;
        setOverflowExpandedNew(false);
        return;
      }

      const isSelectedInOverflow = !!(selectedLabel && overflowGridNew.contains(selectedLabel));
      if (!sizeOverflowUserToggledNew) {
        setOverflowExpandedNew(false);
        return;
      }

      if (isSelectedInOverflow || !overflowGridNew.hidden) {
        setOverflowExpandedNew(true);
      }
    };

    const autoSelectRecommendedSizeNew = (input) => {
      if (!input || input.disabled) return;

      const selectedInput = frameSizeSectionNew.querySelector('input[name="frameSize"]:checked');
      if (selectedInput === input) return;

      isAutoSelectingRecommendedSizeNew = true;
      try {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      } finally {
        isAutoSelectingRecommendedSizeNew = false;
      }
    };

    const highlightRelatedOptionNew = (targetValue) => {
      const normalizedTarget = normalizeFrameSizeValueNew(targetValue);
      sizeOptionInputsNew.forEach((input) => {
        const normalizedInput = normalizeFrameSizeValueNew(input.value);
        if (normalizedInput === normalizedTarget) {
          markSizeRecommendationNew(input, "related", "orange");
        }
      });
    };

    const highlightMatchingOptionNew = () => {
      clearSizeRecommendationStateNew();

      const imgRatioEl = document.getElementById("img-ratio");
      const ratioValue = imgRatioEl?.textContent.trim() || imgRatioEl?.value?.trim();

      if (!ratioValue) {
        lastRecommendationContextKeyNew = "";
        sizeAutoSelectionLockedByUserNew = false;
        restoreAllSizeOptionsNew();
        return false;
      }

      const recommendationContextKeyNew = getRecommendationContextKeyNew(ratioValue);
      if (recommendationContextKeyNew !== lastRecommendationContextKeyNew) {
        lastRecommendationContextKeyNew = recommendationContextKeyNew;
        sizeAutoSelectionLockedByUserNew = false;
      }

      const highlightedOptionsNew = [];
      let matchFoundNew = false;
      let firstRecommendedInputNew = null;

      sizeOptionInputsNew.forEach((input) => {
        const lRatio = input.getAttribute("data-l-ratio");
        const pRatio = input.getAttribute("data-p-ratio");

        if (ratioValue === lRatio || ratioValue === pRatio) {
          markSizeRecommendationNew(input, "recommended", "green");
          matchFoundNew = true;

          if (!firstRecommendedInputNew && !input.disabled) {
            firstRecommendedInputNew = input;
          }

          const normalizedSizeValue = normalizeFrameSizeValueNew(input.value);
          if (!highlightedOptionsNew.includes(normalizedSizeValue)) {
            highlightedOptionsNew.push(normalizedSizeValue);
          }
        }
      });

      if (matchFoundNew) {
        highlightedOptionsNew.forEach((value) => {
          if (relatedOptionsMapNew[value]) {
            relatedOptionsMapNew[value].forEach((relatedValue) => {
              highlightRelatedOptionNew(relatedValue);
            });
          }
        });
      }

      applyRecommendedSizeVisibilityNew();
      if (!sizeAutoSelectionLockedByUserNew && matchFoundNew && firstRecommendedInputNew) {
        autoSelectRecommendedSizeNew(firstRecommendedInputNew);
      }
      return matchFoundNew;
    };

    overflowToggleNew.addEventListener("click", () => {
      sizeOverflowUserToggledNew = true;
      setOverflowExpandedNew(overflowGridNew.hidden);
    });

    frameSizeSectionNew.addEventListener("change", (event) => {
      if (event.target.name === "frameSize") {
        if (!isAutoSelectingRecommendedSizeNew) {
          sizeAutoSelectionLockedByUserNew = true;
        }
        applyRecommendedSizeVisibilityNew();
      }
    });

    document.getElementById("frameOrientationOptions")?.addEventListener("change", () => {
      if (!autoOrientationPreferenceInProgress) {
        sizeAutoSelectionLockedByUserNew = true;
      }
      window.setTimeout(highlightMatchingOptionNew, 0);
    });

    window.refreshFrameSizeRecommendations = highlightMatchingOptionNew;

    let ratioCheckAttemptsNew = 0;
    const ratioCheckIntervalNew = setInterval(() => {
      ratioCheckAttemptsNew += 1;
      const done = highlightMatchingOptionNew();
      if (done || ratioCheckAttemptsNew >= 40) {
        clearInterval(ratioCheckIntervalNew);
      }
    }, 300);

    return;
  }

  const highlightedOptions = [];

  const relatedOptionsMapClean = {
    "9x12": ["18x26", "20x28", "28x40", "40x55"],
    "12x16": ["18x26", "20x28", "28x40", "40x55"],
    "18x24": ["18x26", "20x28", "28x40", "40x55"],
    "24x32": ["18x26", "20x28", "28x40", "40x55"],
    "30x40": ["18x26", "20x28", "28x40", "40x55"],
    "8x12": ["26x40"],
    "12x18": ["26x40"],
    "16x24": ["26x40"],
    "20x30": ["26x40"],
    "24x36": ["26x40"],
    "32x48": ["26x40"],
    "40x60": ["26x40"],
    "8x10": ["11x14", "20x24"],
    "16x20": ["11x14", "20x24"],
    "24x30": ["11x14", "20x24"],
  };

  const normalizeFrameSizeValue = (value) => {
    const numberParts = String(value || "").match(/\d+(?:\.\d+)?/g);
    if (!numberParts || numberParts.length < 2) {
      return String(value || "").trim().toLowerCase();
    }
    return `${numberParts[0]}x${numberParts[1]}`;
  };

  const relatedOptionsMap = {
    '9″×12″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '12″×16″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '18″×24″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '24″×32″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '30″×40″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '8″×12″': ["26″×40″"],
    '12″×18″': ["26″×40″"],
    '16″×24″': ["26″×40″"],
    '20″×30″': ["26″×40″"],
    '24″×36″': ["26″×40″"],
    '32″×48″': ["26″×40″"],
    '40″×60″': ["26″×40″"],
    '8″×10″': ["11″×14″", "20″×24″"],
    '16″×20″': ["11″×14″", "20″×24″"],
    '24″×30″': ["11″×14″", "20″×24″"],
  };

  function highlightMatchingOption() {
    const hiddenimg = document.getElementById("frame-img-position");
    const orientationRadio = document.querySelector('input[name="orientation"]:checked');
    const orientation = orientationRadio ? orientationRadio.value : "portrait";

    // ⛔ STOP if orientation is NOT portrait
    if (orientation !== "portrait") {
      return true;  // stop interval
    }

    const imgRatioEl = document.getElementById("img-ratio");
    if (!imgRatioEl) {
      return;
    }

    const ratioValue = imgRatioEl.textContent.trim() || imgRatioEl.value?.trim();
    if (!ratioValue) {
      return false;
    }

    const options = document.querySelectorAll("#frameSizeOptions label.frame-size-btn input");
    let matchFound = false;

    options.forEach((input, index) => {
      const lRatio = input.getAttribute("data-l-ratio");
      const pRatio = input.getAttribute("data-p-ratio");
      const label = input.closest("label.frame-size-btn").querySelector("span");

      if (ratioValue === lRatio || ratioValue === pRatio) {
        // label.style.border = "1px solid green";

        matchFound = true;

        const normalizedSizeValue = normalizeFrameSizeValue(input.value);
        if (!highlightedOptions.includes(normalizedSizeValue)) {
          highlightedOptions.push(normalizedSizeValue);
        }
      }
    });

    if (matchFound) {
      highlightedOptions.forEach((val) => {
        if (relatedOptionsMapClean[val]) {
          relatedOptionsMapClean[val].forEach((relatedVal) => {
            highlightRelatedOption(relatedVal);
          });
        }
      });
    }

    return true;
  }

  function highlightRelatedOption(targetValue) {
    const options = document.querySelectorAll("#frameSizeOptions label.frame-size-btn input ");
    const targetKey = normalizeFrameSizeValue(targetValue);

    options.forEach((input) => {
      const normalizedInput = input.value.replace(/[“”"]/g, '"').replace(/[×x]/g, "x");
      const normalizedTarget = targetValue.replace(/[“”"]/g, '"').replace(/[×x]/g, "x");
      const inputKey = normalizeFrameSizeValue(input.value);
      if (inputKey === targetKey) {
        const label = input.closest("label.frame-size-btn").querySelector("span");
        label.style.border = "1px solid orange";

        if (!highlightedOptions.includes(inputKey)) {
          highlightedOptions.push(inputKey);
        }
      }
    });
  }

  const ratioCheckInterval = setInterval(() => {
    const done = highlightMatchingOption();
    if (done) {
      clearInterval(ratioCheckInterval);
    }
  }, 300);
});

const canvasnew = document.getElementById('canvasnew');
const fileInput1 = document.getElementById('upload-image');
const ctx = canvasnew.getContext('2d');
const expandBtn = document.getElementById('expandBtn');

let img = new Image();
img.crossOrigin = "anonymous";

// 🧮 Calculate expanded size
function calculateExpandedSize({
  imageWidthPx,
  imageHeightPx,
  imageWidthInch,
  imageHeightInch,
  canvasWidthInch,
  canvasHeightInch
}) {
  const extraWidthInch = canvasWidthInch - imageWidthInch;
  const extraHeightInch = canvasHeightInch - imageHeightInch;

  const extraWidthPx = (extraWidthInch * imageWidthPx) / imageWidthInch;
  const extraHeightPx = (extraHeightInch * imageHeightPx) / imageHeightInch;

  const finalWidthPx = imageWidthPx + extraWidthPx;
  const finalHeightPx = imageHeightPx + extraHeightPx;

  return { extraWidthPx, extraHeightPx, finalWidthPx, finalHeightPx };
}

expandBtn.addEventListener('click', async () => {
  if (!appState.uploadedImage) {
    alert("Please upload an image first!");
    return;
  }

  const imgWidthPx = appState.uploadedImage.width;
  const imgHeightPx = appState.uploadedImage.height;
  const imgWidthIn = appState.printimgwidth;
  const imgHeightIn = appState.printimghight;
  const canvasWidthIn = appState.extendwidth;
  const canvasHeightIn = appState.extendheight;

  // ✅ Get user and session IDs
  const userId = window.shopifyCustomerId || "guest";
  const sessionId = getLocalStorage1Day("sessionId") || "none";

  if (!fileInput1.files[0]) {
    alert("Please upload an image first!");
    return;
  }

  const size = calculateExpandedSize({
    imageWidthPx: imgWidthPx,
    imageHeightPx: imgHeightPx,
    imageWidthInch: imgWidthIn,
    imageHeightInch: imgHeightIn,
    canvasWidthInch: canvasWidthIn,
    canvasHeightInch: canvasHeightIn
  });

  const reader = new FileReader();
  reader.onload = e => {
    img.src = e.target.result;
    img.onload = async () => await processImage(size);
  };
  reader.readAsDataURL(fileInput1.files[0]);

  // 🧩 Process & Upload
  async function processImage(size) {
    const { finalWidthPx, finalHeightPx } = size;

    // Draw expanded image
    canvasnew.width = finalWidthPx;
    canvasnew.height = finalHeightPx;

    ctx.fillStyle = "#000";
    ctx.fillRect(0, 0, canvasnew.width, canvasnew.height);

    const x = (canvasnew.width - imgWidthPx) / 2;
    const y = (canvasnew.height - imgHeightPx) / 2;

    ctx.drawImage(img, x, y, imgWidthPx, imgHeightPx);

    // Convert to Blob
    const blob = await new Promise(resolve => canvasnew.toBlob(resolve, 'image/jpeg'));
    const file = new File([blob], "expanded-image.jpeg", { type: "image/jpeg" });

    // 🔹 Prepare FormData
    const formData = new FormData();
    formData.append("customerId", userId);
    formData.append("sessionId", sessionId);
    formData.append("file", file);

    try {
      const response = await fetch(`${window.Prompt2Prints.apiBase}/upload-image`, {
        method: "POST",
        headers: {
          "x-api-key": window.Prompt2Prints.apiKey
        },
        body: formData
      });

      if (!response.ok) throw new Error(`Upload failed (${response.status})`);
      const result = await response.json();

      const imageUpscale = document.querySelector('input[name="properties[_pdp-allow-upscale]"]');
      const imageUpscaletag = document.querySelector('input[name="properties[_pdp-img-tag]"]');

      if (!imageUpscale || !imageUpscaletag) {
        console.warn("Upscale inputs not found");
        return;
      }

      const flag = (result.flag || "").toLowerCase();

      if (flag === "standard") {
        imageUpscale.value = "true";
        imageUpscaletag.value = "Standard";
      }
      else if (flag === "professional") {
        imageUpscale.value = "false";
        imageUpscaletag.value = "Professional";
      }
      else {
        imageUpscale.value = "";
        imageUpscaletag.value = "";
      }

      // Optional: also update attribute for Shopify forms
      imageUpscale.setAttribute("value", imageUpscale.value);
      imageUpscaletag.setAttribute("value", imageUpscaletag.value);
      // 🖼️ Auto-download after successful upload
      const base64 = canvasnew.toDataURL('image/jpeg');
      const link = document.createElement('a');
      link.download = 'expanded-image.jpeg';
      link.href = base64;
      link.click();

    } catch (err) {
      console.error("❌ Upload error:", err);
      alert("Upload failed. Please try again.");
    }
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const items = document.querySelectorAll(".pdp-option-main-wrap");

//   items.forEach(item => {
//     const header = item.querySelector(".pdp-option-title-wrap.is-layout");
//     const content = item.querySelector(".orientation-options");
//     const arrow = item.querySelector(".pdp-option-arrow");

//     if (!header || !content) return;

//     content.style.display = "none";

//     // Default open
//     if (item.classList.contains("default-open")) {
//       item.classList.add("active");
//       header.setAttribute("aria-expanded", "true");
//       content.style.display = "grid";
//       if (arrow) arrow.style.transform = "rotate(180deg)";
//     }

//     header.addEventListener("click", () => {
//       const expanded = header.getAttribute("aria-expanded") === "true";

//       item.classList.toggle("active");
//       header.setAttribute("aria-expanded", !expanded);

//       if (expanded) {
//         content.style.display = "none";
//         if (arrow) arrow.style.transform = "rotate(0deg)";
//       } else {
//         content.style.display = "grid";
//         if (arrow) arrow.style.transform = "rotate(180deg)";
//       }
//     });
//   });
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const items = document.querySelectorAll(".frame-sizes");

//   items.forEach(item => {
//     const header = item.querySelector(".pdp-option-title-wrap.is-size");
//     const content = item.querySelector(".frame-size-options");
//     const arrow = item.querySelector(".pdp-option-arrow");

//     if (!header || !content) return;

//     content.style.display = "none";

//     // Default open
//     if (item.classList.contains("default-open")) {
//       item.classList.add("active");
//       header.setAttribute("aria-expanded", "true");
//       content.style.display = "flex";
//       if (arrow) arrow.style.transform = "rotate(180deg)";
//     }

//     header.addEventListener("click", () => {
//       const expanded = header.getAttribute("aria-expanded") === "true";

//       item.classList.toggle("active");
//       header.setAttribute("aria-expanded", !expanded);

//       if (expanded) {
//         content.style.display = "none";
//         if (arrow) arrow.style.transform = "rotate(0deg)";
//       } else {
//         content.style.display = "flex";
//         if (arrow) arrow.style.transform = "rotate(180deg)";
//       }
//     });
//   });
// });

// ============================================
// 3D TOGGLE LOADING SCREEN
// ============================================
document.addEventListener("DOMContentLoaded", function () {
    const threeToggle = document.getElementById("toggleSplit");
    if (!threeToggle || threeToggle.dataset.canvas3dLoaderBound === "1") return;
    threeToggle.dataset.canvas3dLoaderBound = "1";

    threeToggle.addEventListener("change", function () {
        if (!threeToggle.checked) return;

        const overlay = document.getElementById("preview3dLoadingOverlay");
        const splitView = document.getElementById("splitView");
        if (!overlay || !splitView) return;

        const rect = splitView.getBoundingClientRect();
        overlay.style.width = rect.width + "px";
        overlay.style.height = rect.height + "px";

        overlay.classList.add("active");
        window.setTimeout(function () {
            overlay.classList.remove("active");
        }, 2000);
    });
});

// Helper functions that were missing
function getLocalStorage1Day(key) {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;

    // Check if the item is already a JSON string with expiry
    if (item.startsWith('{') && item.includes('"expiry"')) {
      const { value, expiry } = JSON.parse(item);

      // Check if the item has expired
      if (Date.now() > expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return value;
    } else {
      // It's a regular string, return as-is
      return item;
    }
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    // Return the raw item if parsing fails
    return item;
  }
}
function setLocalStorage1Day(key, value) {
  try {
    // Set expiry to 1 day from now
    const expiry = Date.now() + (24 * 60 * 60 * 1000);
    const item = JSON.stringify({ value, expiry });
    localStorage.setItem(key, item);
  } catch (error) {
    console.error('Error writing to localStorage:', error);
  }
}

// Initialize any missing appState properties
if (!appState.uploadedImageForBlackEdge) {
  appState.uploadedImageForBlackEdge = null;
}



function setWrap() {
  const value = storeSelectedWrap(sessionStorage.getItem("selectedWrap"));

  if (isMirrorWrapValue(value)) {
    appState.selectedEdgeType = "MirrorWrap";
    coverFrame("black");
  }
  else if (isBlurWrapValue(value)) {
    appState.selectedEdgeType = "WhiteWrap";
    coverFrame("white");
  }
  else if (isFitToEdgeWrapValue(value)) {
    appState.selectedEdgeType = "FitToEdge";
    applyFitToEdgeWrapSelection();
  }
  else if (isFrontFitWrapValue(value)) {
    appState.selectedEdgeType = "FitToEdge";
    applyFrontFitWrapSelection();
  }
}

function refreshWrapSelectionPreview() {
  updatePositionInfo();
  const wrapClamped = enforceMinimumDpi(MIN_PRINT_DPI);
  if (wrapClamped) showZoomLimitMessage();
  updateDpiDisplay();
  syncZoomSlider();
  updateZoomControlsState();
  triggerThreeDPreview();
  if (typeof window.renderFlatFrontPreview === "function") {
    window.renderFlatFrontPreview();
  }
}

function applyFitToEdgeWrapSelection() {
  fitImageToFrame(true);
  refreshWrapSelectionPreview();
}

function applyFrontFitWrapSelection() {
  FitFrontFrame();
  refreshWrapSelectionPreview();
}


document.getElementById("fill-front-image").addEventListener("click", () => {
  // coverFrame1() sets scale + refreshes appState.dpi via updatePositionInfo()
  coverFrame1();
  // Clamp zoom down if image resolution is too low (DPI < MIN_PRINT_DPI)
  const fillFrontClamped = enforceMinimumDpi(MIN_PRINT_DPI);
  if (fillFrontClamped) showZoomLimitMessage();
  updateDpiDisplay();
  syncZoomSlider();
  updateZoomControlsState();
});
document.getElementById("fill-side-image").addEventListener("click", () => {
  applyFitToEdgeWrapSelection();
});
document.getElementById("fit-front-image").addEventListener("click", () => {
  applyFrontFitWrapSelection();
});

document.getElementById("center-image").addEventListener("click", () => {
  centerImage();
  updatePositionInfo();
  const centerClamped = enforceMinimumDpi(MIN_PRINT_DPI);
  if (centerClamped) showZoomLimitMessage();
  updateDpiDisplay();
  syncZoomSlider();
  updateZoomControlsState();
});

window.getLocalStorage1Day = getLocalStorage1Day;
window.setLocalStorage1Day = setLocalStorage1Day;
window.appState = appState;

const frameNoteClose = document.querySelector('.frm-note-close');
const frameNote = document.querySelector('.frm-image-note');
if (frameNoteClose && frameNote) {
  frameNoteClose.addEventListener('click', () => {
    frameNote.style.display = 'none';
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const previewToggle = document.getElementById("toggleSplit");
  const previewPills = Array.from(document.querySelectorAll("[data-preview-mode]"));
  const splitView = document.getElementById("splitView");
  const leftCanvasPanel = splitView?.querySelector(".canvas-panel.left-panel");
  const rightCanvasPanel = splitView?.querySelector(".canvas-panel.right-panel");
  const flatFrontPreviewWrap = splitView?.querySelector("[data-flat-front-preview]");
  const flatFrontPreviewCanvas = splitView?.querySelector("[data-flat-preview-canvas]");
  const divider = document.getElementById("divider");
  const dividerLine = document.getElementById("divider-line");

  const flatPreviewFaces = {
    front: flatFrontPreviewCanvas?.querySelector(".flat-preview-face.front"),
    left: flatFrontPreviewCanvas?.querySelector(".flat-preview-face.left"),
    right: flatFrontPreviewCanvas?.querySelector(".flat-preview-face.right"),
    top: flatFrontPreviewCanvas?.querySelector(".flat-preview-face.top"),
    bottom: flatFrontPreviewCanvas?.querySelector(".flat-preview-face.bottom")
  };

  const getPreviewNumber = (id, fallback = 0) => {
    const rawValue = document.getElementById(id)?.textContent ?? fallback;
    const parsedValue = parseFloat(String(rawValue).replace(/[^\d.-]/g, ""));
    return Number.isFinite(parsedValue) ? parsedValue : fallback;
  };

  let flatPreviewSourceCache = {
    src: "",
    image: null,
    promise: null
  };
  let flatPreviewRenderToken = 0;

  const getFlatPreviewImageSource = () => {
    const mainImageData = document.querySelector(".main-img-wrap")?.getAttribute("data-main-img");
    if (mainImageData) return mainImageData;

    if (appState.uploadedImage) {
      if (typeof appState.uploadedImage.getSrc === "function") {
        const fabricSrc = appState.uploadedImage.getSrc();
        if (fabricSrc) return fabricSrc;
      }

      const elementSrc =
        appState.uploadedImage._originalElement?.currentSrc ||
        appState.uploadedImage._originalElement?.src ||
        appState.uploadedImage._element?.currentSrc ||
        appState.uploadedImage._element?.src;

      if (elementSrc) return elementSrc;
    }

    return "";
  };

  const loadFlatPreviewImage = (src) => {
    if (!src) return Promise.resolve(null);

    if (flatPreviewSourceCache.src === src && flatPreviewSourceCache.image?.complete) {
      return Promise.resolve(flatPreviewSourceCache.image);
    }

    if (flatPreviewSourceCache.src === src && flatPreviewSourceCache.promise) {
      return flatPreviewSourceCache.promise;
    }

    flatPreviewSourceCache = {
      src,
      image: null,
      promise: new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          flatPreviewSourceCache.image = img;
          flatPreviewSourceCache.promise = null;
          resolve(img);
        };
        img.onerror = (error) => {
          flatPreviewSourceCache.image = null;
          flatPreviewSourceCache.promise = null;
          reject(error);
        };
        img.src = src;
      })
    };

    return flatPreviewSourceCache.promise;
  };

  const makeFlatFaceDataUrl = (img, sx, sy, sw, sh, scaleX, scaleY) => {
    if (!img || !img.naturalWidth) return "";

    const maxSize = 1600;
    let srcX = Math.round(sx * scaleX);
    let srcY = Math.round(sy * scaleY);
    let srcW = Math.round(sw * scaleX);
    let srcH = Math.round(sh * scaleY);

    if (srcW <= 0 || srcH <= 0) return "";

    const sourceAspect = srcW / srcH;
    let targetWidth;
    let targetHeight;

    if (sourceAspect > 1) {
      targetWidth = maxSize;
      targetHeight = Math.max(1, Math.round(maxSize / sourceAspect));
    } else {
      targetHeight = maxSize;
      targetWidth = Math.max(1, Math.round(maxSize * sourceAspect));
    }

    const previewCanvas = document.createElement("canvas");
    previewCanvas.width = targetWidth;
    previewCanvas.height = targetHeight;

    const ctx = previewCanvas.getContext("2d");
    if (!ctx) return "";

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    // ctx.fillStyle = "#ffffff";
    // ctx.fillRect(0, 0, targetWidth, targetHeight);

    const clipLeft = Math.max(0, -srcX);
    const clipTop = Math.max(0, -srcY);
    const clipRight = Math.max(0, srcX + srcW - img.naturalWidth);
    const clipBottom = Math.max(0, srcY + srcH - img.naturalHeight);

    let destX = (clipLeft / srcW) * targetWidth;
    let destY = (clipTop / srcH) * targetHeight;
    let destW = targetWidth - (((clipLeft + clipRight) / srcW) * targetWidth);
    let destH = targetHeight - (((clipTop + clipBottom) / srcH) * targetHeight);

    srcX += clipLeft;
    srcY += clipTop;
    srcW -= clipLeft + clipRight;
    srcH -= clipTop + clipBottom;

   
    if (srcW > 0 && srcH > 0 && destW > 0 && destH > 0) {
     const bleed = 1;

destX = Math. floor(destX) - bleed;
destY = Math. floor(destY) - bleed;
destW = Math.ceil(destW) + bleed * 2;
destH = Math.ceil(destH) + bleed * 2;
ctx.drawImage(img, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
    }

    return previewCanvas.toDataURL("image/png");
  };

  const applyFlatPreviewAngle = () => {
    if (!flatFrontPreviewCanvas) return;

    const angle = flatFrontPreviewCanvas.dataset.angle;
    const angleTransforms = {
      left: "rotateY(32deg) rotateX(0deg)",
      right: "rotateY(325deg) rotateX(0deg)"
    };

    flatFrontPreviewCanvas.style.transform = angleTransforms[angle] || "rotateY(0deg) rotateX(0deg)";
  };

  window.renderFlatFrontPreview = function () {
    if (!flatFrontPreviewWrap || !flatFrontPreviewCanvas) return;

    applyFlatPreviewAngle();

    const imageSource = getFlatPreviewImageSource();
    const frameWidth = getPreviewNumber("frm-w", appState.selectedWidth || 0);
    const frameHeight = getPreviewNumber("frm-h", appState.selectedHeight || 0);
    const finalImageWidth = getPreviewNumber("img-f-w", frameWidth || 1);
    const finalImageHeight = getPreviewNumber("img-f-h", frameHeight || 1);
    const offsetX = -getPreviewNumber("f-l", 0);
    const offsetY = -getPreviewNumber("f-t", 0);

    if (!frameWidth || !frameHeight) {
      flatFrontPreviewWrap.classList.add("is-empty");
      return;
    }

    const frontImageWidth = Math.max(1, frameWidth);
    const frontImageHeight = Math.max(1, frameHeight);

    const hostRect = flatFrontPreviewWrap.getBoundingClientRect();
    const frameColorInput = document.querySelector('input[name="frameColor"]:checked');
    const selectedFrameValue = (frameColorInput?.value || "").toLowerCase();
    const frameColorMap = {
      black: "#1d1d1d",
      brown: "#6f4a2b",
      walnut: "#6f4a2b",
      white: "#ece8e1"
    };

    const frameColor = frameColorInput?.dataset.color || frameColorMap[selectedFrameValue] || "#6f4a2b";
    const availableWidth = Math.max(
      200,
      (hostRect.width || leftCanvasPanel?.clientWidth || 420) - 56
    );
    const availableHeight = Math.max(
      220,
      (hostRect.height || leftCanvasPanel?.clientHeight || 560) - 56
    );

    const framePadding = Math.max(10, Math.min(18, Math.round(Math.min(availableWidth, availableHeight) * 0.035)));
    const displayScale = Math.max(
      0.05,
      Math.min(
        (availableWidth - (framePadding * 2)) / frameWidth,
        (availableHeight - (framePadding * 2)) / frameHeight
      )
    );

    const frontWidth = Math.max(24, frameWidth * displayScale);
    const frontHeight = Math.max(24, frameHeight * displayScale);
    const sideDepth = Math.max(
      6,
      Math.min(12, Math.round(Math.min(frontWidth, frontHeight) * 0.02))
    );
    const outerWidth = frontWidth + (framePadding * 2);
    const outerHeight = frontHeight + (framePadding * 2);

    flatFrontPreviewCanvas.style.width = `${outerWidth}px`;
    flatFrontPreviewCanvas.style.height = `${outerHeight}px`;
    flatFrontPreviewCanvas.style.setProperty("--flat-preview-frame-color", frameColor);

    if (flatPreviewFaces.front) {
      flatPreviewFaces.front.style.width = `${frontWidth}px`;
      flatPreviewFaces.front.style.height = `${frontHeight}px`;
      flatPreviewFaces.front.style.left = `${framePadding}px`;
      flatPreviewFaces.front.style.top = `${framePadding}px`;
    }

    if (flatPreviewFaces.left) {
      flatPreviewFaces.left.style.width = `${sideDepth}px`;
      flatPreviewFaces.left.style.height = `${frontHeight}px`;
      flatPreviewFaces.left.style.left = `${framePadding}px`;
      flatPreviewFaces.left.style.top = `${framePadding}px`;
    }

    if (flatPreviewFaces.right) {
      flatPreviewFaces.right.style.width = `${sideDepth}px`;
      flatPreviewFaces.right.style.height = `${frontHeight}px`;
      flatPreviewFaces.right.style.left = `${framePadding + frontWidth}px`;
      flatPreviewFaces.right.style.top = `${framePadding}px`;
    }

    if (flatPreviewFaces.top) {
      flatPreviewFaces.top.style.width = `${frontWidth}px`;
      flatPreviewFaces.top.style.height = `${sideDepth}px`;
      flatPreviewFaces.top.style.left = `${framePadding}px`;
      flatPreviewFaces.top.style.top = `${framePadding}px`;
    }

    if (flatPreviewFaces.bottom) {
      flatPreviewFaces.bottom.style.width = `${frontWidth}px`;
      flatPreviewFaces.bottom.style.height = `${sideDepth}px`;
      flatPreviewFaces.bottom.style.left = `${framePadding}px`;
      flatPreviewFaces.bottom.style.top = `${framePadding + frontHeight}px`;
    }

    const normalizedImageSource = imageSource && !String(imageSource).startsWith("data:image")
      ? encodeURI(imageSource)
      : imageSource;

    const getSideEdgeColor = () => {
      const frameColorInput = document.querySelector('input[name="frameColor"]:checked');
      const frameColorValue = (frameColorInput?.value || "Black").toLowerCase();
      return frameColorValue === "white" ? "#ffffff" : "#000000";
    };

    const applyRenderedFace = (frontTextureUrl) => {
      const sideColor = getSideEdgeColor();

      const frontFace = flatPreviewFaces.front;
      if (frontFace) {
        frontFace.style.backgroundImage = frontTextureUrl ? `url("${frontTextureUrl}")` : "none";
        frontFace.style.backgroundRepeat = "no-repeat";
        frontFace.style.backgroundSize = "calc(100% + 2px) calc(100% + 2px)";
        frontFace.style.backgroundPosition = "center center";
        frontFace.style.backgroundColor = "#ffffff";
      }

      ["left", "right", "top", "bottom"].forEach(faceName => {
        const face = flatPreviewFaces[faceName];
        if (!face) return;
        face.style.backgroundImage = "none";
        face.style.backgroundColor = sideColor;
      });

      flatFrontPreviewWrap.classList.toggle("is-empty", !frontTextureUrl);
    };

    if (!normalizedImageSource) {
      applyRenderedFace("");
      return;
    }

    const renderToken = ++flatPreviewRenderToken;

    loadFlatPreviewImage(normalizedImageSource)
      .then((img) => {
        if (!img || renderToken !== flatPreviewRenderToken) return;

        const scaleX = img.naturalWidth / Math.max(1, finalImageWidth);
        const scaleY = img.naturalHeight / Math.max(1, finalImageHeight);
        const frontTextureUrl = makeFlatFaceDataUrl(
          img,
          offsetX,
          offsetY,
          frontImageWidth,
          frontImageHeight,
          scaleX,
          scaleY
        );

        applyRenderedFace(frontTextureUrl);
      })
      .catch((error) => {
        if (renderToken !== flatPreviewRenderToken) return;
        console.warn("Failed to render flat front preview from source image:", error);
        applyRenderedFace("");
      });
  };

  window.fitFlatViewCanvasToPanel = function (forcedWidth, forcedHeight) {
    if (!canvas || !canvas.wrapperEl) {
      if (typeof window.renderFlatFrontPreview === "function") {
        window.renderFlatFrontPreview();
      }
      return;
    }

    const hostPanel = leftCanvasPanel || document.querySelector(".canvas-wrap");
    const hostRect = hostPanel?.getBoundingClientRect();
    const sourceWidth = forcedWidth || canvas.getWidth();
    const sourceHeight = forcedHeight || canvas.getHeight();

    if (!sourceWidth || !sourceHeight) return;

    const availableWidth = Math.max(180, (hostRect?.width || 360) - 64);
    const availableHeight = Math.max(180, (hostRect?.height || 520) - 64);
    const scale = Math.min(availableWidth / sourceWidth, availableHeight / sourceHeight);
    const displayWidth = Math.max(140, Math.round(sourceWidth * scale));
    const displayHeight = Math.max(140, Math.round(sourceHeight * scale));

    canvas.wrapperEl.style.width = `${displayWidth}px`;
    canvas.wrapperEl.style.height = `${displayHeight}px`;
    canvas.wrapperEl.style.maxWidth = `${displayWidth}px`;
    canvas.wrapperEl.style.maxHeight = `${displayHeight}px`;
    canvas.wrapperEl.style.margin = "0 auto";

    canvas.getElement().style.width = "100%";
    canvas.getElement().style.height = "100%";
    if (canvas.upperCanvasEl) {
      canvas.upperCanvasEl.style.width = "100%";
      canvas.upperCanvasEl.style.height = "100%";
    }
    if (canvas.lowerCanvasEl) {
      canvas.lowerCanvasEl.style.width = "100%";
      canvas.lowerCanvasEl.style.height = "100%";
    }

    if (typeof window.renderFlatFrontPreview === "function") {
      window.renderFlatFrontPreview();
    }
  };

  const normalizeText = (value) => String(value || "")
    .replace(/â€³|″|”/g, '"')
    .replace(/â€²|′|’/g, "'")
    .replace(/Ã—|×/g, "x")
    .replace(/\s*x\s*/gi, " x ")
    .replace(/\s+/g, " ")
    .trim();

  const cleanDisplayText = (value) => String(value || "")
    .replace(/[\u2033\u201d]/g, '"')
    .replace(/[\u2032\u2019]/g, "'")
    .replace(/\u00d7/g, "x")
    .replace(/\s*x\s*/gi, " x ")
    .replace(/\s+/g, " ")
    .trim();

  const titleCase = (value) => {
    const text = cleanDisplayText(value).toLowerCase();
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  };

  const formatFrameColor = (value) => {
    const normalized = cleanDisplayText(value);
    if (!normalized) return "Black";
    if (normalized.toLowerCase() === "brown") return "Walnut";
    return normalized;
  };

  const formatWrapLabel = (value) => {
    switch (normalizeWrapValue(value)) {
      case "mirrorwrap":
        return "Mirror";
      case "blurwrap":
        return "Blur";
      case "frontfit":
        return "Fit To Front Face";
      case "fit":
        return "Fill To Edge";
      default:
        return "Fit To Front Face";
    }
  };

  const getVariantMoney = (variant, fieldName) => {
    if (!variant) return null;

    const directValue = variant[fieldName];
    if (typeof directValue === "number") return directValue / 100;
    if (directValue && typeof directValue.amount !== "undefined") {
      return parseFloat(directValue.amount);
    }

    const fallbackField = fieldName === "price" ? "priceV2" : "compare_at_priceV2";
    const fallbackValue = variant[fallbackField];
    if (fallbackValue && typeof fallbackValue.amount !== "undefined") {
      return parseFloat(fallbackValue.amount);
    }

    return null;
  };

  const formatMoney = (amount) => (
    Number.isFinite(amount) ? `$${amount.toFixed(2)}` : ""
  );

  const getSelectedVariant = () => {
    const selectedSize = document.querySelector('input[name="frameSize"]:checked')?.value;
    if (!selectedSize || !Array.isArray(window.productVariants)) return null;

    return window.productVariants.find((variant) => variant.option1 === selectedSize) || null;
  };

  const syncCanvasOptionLabels = () => {
    const selectedOrientation = document.querySelector('input[name="orientation"]:checked')?.value || "portrait";
    const selectedSize = document.querySelector('input[name="frameSize"]:checked')?.value || "";
    const selectedFrameColor = document.querySelector('input[name="frameColor"]:checked')?.value || "Black";
    const selectedWrap = normalizeWrapValue(
      document.querySelector('input[name="wrap_type"]:checked')?.value ||
      sessionStorage.getItem("selectedWrap") ||
      "frontfit"
    );

    const sizeLabel = cleanDisplayText(selectedSize);
    const orientationLabel = titleCase(selectedOrientation);
    const frameColorLabel = formatFrameColor(selectedFrameColor);
    const wrapLabel = formatWrapLabel(selectedWrap);

    document.querySelectorAll("[data-current-orientation]").forEach((node) => {
      node.textContent = orientationLabel;
    });

    

      document.querySelectorAll("[data-preview-size-label]").forEach((node) => {
      node.textContent = "Poster: " + sizeLabel;
    });

    document.querySelectorAll("[data-current-size]").forEach((node) => {
      node.textContent = sizeLabel;
    });

    document.querySelectorAll("[data-current-frame-color]").forEach((node) => {
      node.textContent = frameColorLabel;
    });

    document.querySelectorAll("[data-current-wrap]").forEach((node) => {
      node.textContent = wrapLabel;
    });
  };

  const syncCanvasPriceUi = () => {
    const variant = getSelectedVariant();
    if (!variant) return;

    let price = getVariantMoney(variant, "price");
    const comparePrice = getVariantMoney(variant, "compare_at_price");

    if (Number.isFinite(price) && window.isPremiumCustomer === true) {
      price = price * 0.9;
    }

    const priceText = formatMoney(price);
    const compareText = formatMoney(comparePrice);
    const hasCompare = Number.isFinite(comparePrice) && comparePrice > price;
    const discountPercent = hasCompare
      ? Math.round(((comparePrice - price) / comparePrice) * 100)
      : 0;

    document.querySelectorAll(".main-price").forEach((node) => {
      node.textContent = priceText;
    });

    document.querySelectorAll(".compare-price").forEach((node) => {
      if (hasCompare) {
        node.textContent = compareText;
        node.style.display = "";
      } else {
        node.textContent = "";
        node.style.display = "none";
      }
    });

    document.querySelectorAll(".save-percentage").forEach((node) => {
      if (discountPercent > 0) {
        node.textContent = node.dataset.canvasDiscount === "badge"
          ? `${discountPercent}% OFF`
          : `Save ${discountPercent}%`;
        node.style.display = "inline-flex";
      } else {
        node.textContent = "";
        node.style.display = "none";
      }
    });

    document.querySelectorAll("[data-canvas-cta-label]").forEach((node) => {
      node.textContent = "Add to Cart";
    });

    document.querySelectorAll("[data-canvas-cta-price]").forEach((node) => {
      node.textContent = priceText;
    });
  };

  const normalizePreviewMode = (mode) => {
    if (mode === "room") return "room";
    if (mode === "flat") return "flat";
    if (mode === "side") return "side";
    return "3d";
  };

  const usesThreePreviewMode = (mode) => mode === "3d" || mode === "room" || mode === "side";

  let activePreviewMode = "3d";
  const applyPreviewLayout = () => {
    if (!splitView || !leftCanvasPanel || !rightCanvasPanel) return;

    const showThreePreview = previewToggle ? previewToggle.checked : usesThreePreviewMode(activePreviewMode);
    const showFlatView = !showThreePreview && activePreviewMode === "flat";
    const showSideView = showThreePreview && activePreviewMode === "side";

    splitView.classList.toggle("is-3d-view", showThreePreview);
    splitView.classList.toggle("is-flat-view", showFlatView);
    splitView.classList.toggle("is-side-view", showSideView);

    if (flatFrontPreviewCanvas) {
      flatFrontPreviewCanvas.dataset.angle = "front";
    }

    if (flatFrontPreviewWrap) {
      flatFrontPreviewWrap.setAttribute("aria-hidden", showFlatView ? "false" : "true");
    }

    if (typeof window.setThreePreviewViewMode === "function") {
      window.setThreePreviewViewMode(
        activePreviewMode === "side" ? "side" :
        activePreviewMode === "flat" ? "flat" :
        "interactive"
      );
    }

    if (showThreePreview) {
      leftCanvasPanel.classList.add("hide-wrap");
      rightCanvasPanel.classList.remove("hide-wrap");
      rightCanvasPanel.classList.add("show-flex");
    } else {
      leftCanvasPanel.classList.remove("hide-wrap");
      rightCanvasPanel.classList.add("hide-wrap");
      rightCanvasPanel.classList.remove("show-flex");

      if (showFlatView) {
        triggerThreeDPreview();
      } else {
        window.setTimeout(function () {
          if (window.fitFlatViewCanvasToPanel) {
            window.fitFlatViewCanvasToPanel();
          }
        }, 80);
      }
    }

    if (divider) divider.classList.add("hide-wrap");
    if (dividerLine) dividerLine.classList.add("hide-wrap");
  };

  const setPreviewMode = (mode, shouldTriggerToggle) => {
    activePreviewMode = normalizePreviewMode(mode);

    previewPills.forEach((pill) => {
      pill.classList.toggle("is-active", pill.dataset.previewMode === activePreviewMode);
    });

    if (!previewToggle) return;

    const shouldEnable3d = usesThreePreviewMode(activePreviewMode);
    const changed = previewToggle.checked !== shouldEnable3d;
    previewToggle.checked = shouldEnable3d;

    if (shouldTriggerToggle && changed) {
      previewToggle.dispatchEvent(new Event("change", { bubbles: true }));
    }

    applyPreviewLayout();
  };

  previewPills.forEach((pill) => {
    pill.addEventListener("click", function () {
      setPreviewMode(pill.dataset.previewMode || "3d", true);
    });
  });

  if (previewToggle) {
    previewToggle.checked = false;

    previewToggle.addEventListener("change", function () {
      if (!previewToggle.checked) {
        if (usesThreePreviewMode(activePreviewMode)) {
          activePreviewMode = "flat";
        }
      } else if (!usesThreePreviewMode(activePreviewMode)) {
        activePreviewMode = "3d";
      }

      previewPills.forEach((pill) => {
        pill.classList.toggle("is-active", pill.dataset.previewMode === activePreviewMode);
      });

      applyPreviewLayout();
    });
  }

  document
    .querySelectorAll('input[name="frameSize"], input[name="frameColor"], input[name="orientation"], input[name="wrap_type"]')
    .forEach((input) => {
      input.addEventListener("change", function () {
        window.setTimeout(function () {
          syncCanvasOptionLabels();
          syncCanvasPriceUi();
          if (typeof window.renderFlatFrontPreview === "function") {
            window.renderFlatFrontPreview();
          }
        }, 0);
      });
    });

  window.setPreviewMode = setPreviewMode;

  syncCanvasOptionLabels();
  syncCanvasPriceUi();
  setPreviewMode("3d", true);
  applyPreviewLayout();
  window.renderFlatFrontPreview();

  window.addEventListener("resize", function () {
    if (activePreviewMode === "flat" && window.fitFlatViewCanvasToPanel) {
      window.fitFlatViewCanvasToPanel();
    }
  });
});

// ── Drop zone drag-and-drop support ──
(function () {
  const dropzone = document.getElementById("upload-dropzone");
  const fileInput = document.getElementById("upload-image");
  if (!dropzone || !fileInput) return;

  ["dragenter", "dragover"].forEach(function (evt) {
    dropzone.addEventListener(evt, function (e) {
      e.preventDefault();
      e.stopPropagation();
      dropzone.style.background = "rgba(59,130,246,0.12)";
      dropzone.style.borderColor = "#2563eb";
    });
  });

  ["dragleave", "dragend"].forEach(function (evt) {
    dropzone.addEventListener(evt, function (e) {
      e.preventDefault();
      e.stopPropagation();
      dropzone.style.background = "";
      dropzone.style.borderColor = "";
    });
  });

  dropzone.addEventListener("drop", function (e) {
    e.preventDefault();
    e.stopPropagation();
    dropzone.style.background = "";
    dropzone.style.borderColor = "";
    var files = e.dataTransfer && e.dataTransfer.files;
    if (files && files.length > 0) {
      var dt = new DataTransfer();
      dt.items.add(files[0]);
      fileInput.files = dt.files;
      fileInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  dropzone.addEventListener("click", function (e) {
    if (e.target === dropzone || e.target.closest(".upload-dropzone__icon") || e.target.closest(".upload-dropzone__title") || e.target.closest(".upload-dropzone__subtitle")) {
      fileInput.click();
    }
  });
})();

// ── Thumbnail strip: sample image selection ──
(function () {
  var thumbItems = document.querySelectorAll(".upload-thumb-item");
  var fileInput = document.getElementById("upload-image");
  if (!thumbItems.length) return;

  thumbItems.forEach(function (item) {
    item.addEventListener("click", function () {
      thumbItems.forEach(function (t) { t.classList.remove("active"); });
      item.classList.add("active");

      var sampleUrl = item.getAttribute("data-sample-url");
      if (!sampleUrl) return;

      fetch(sampleUrl)
        .then(function (r) { return r.blob(); })
        .then(function (blob) {
          var ext = blob.type === "image/png" ? "png" : "jpg";
          var file = new File([blob], "sample." + ext, { type: blob.type });
          var dt = new DataTransfer();
          dt.items.add(file);
          fileInput.files = dt.files;
          fileInput.dispatchEvent(new Event("change", { bubbles: true }));
        })
        .catch(function (err) {
          console.warn("Could not load sample image:", err);
        });
    });
  });
})();

function updateStickyPadding() {
    if (window.innerWidth > 1160) return;

    const nav = document.querySelector(".p2p-nav-center");
    const sticky = document.querySelector(".sticky-wrap");

    if (!nav || !sticky) return;

    if (nav.classList.contains("p2p-nav-center--hidden")) {
        sticky.style.setProperty("padding-top", "75px", "important");
    } else {
        sticky.style.setProperty("padding-top", "100px", "important");
    }
}

updateStickyPadding();

window.addEventListener("resize", updateStickyPadding);


document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);

  const utmContent = urlParams.get('utm_content');
  const utmCampaign = urlParams.get('utm_campaign');
  const utmMedium = urlParams.get('utm_medium');
  const utmSource = urlParams.get('utm_source');

  if (
    utmContent === 'lacy_polley' &&
    utmCampaign === 'canvas_collab' &&
    utmMedium === 'photography' &&
    utmSource === 'partner'
  ) {
    const banner = document.querySelector('.left-panel-orange-banner');

    if (banner) {
      banner.remove();
    }
      const el = document.querySelector('#pdp-wrap .left-pdp-sticky');

    if (el) {
      el.style.gridTemplateRows = 'max-content';
    }
  }
});
function scrollToPreviewOnMobile() {
  if (window.innerWidth <= 989) {
    const previewSection = document.querySelector('.left-pdp-sticky') || document.querySelector('.canvas-wrap') || document.getElementById('splitView');
    if (previewSection) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = previewSection.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
}
// ===== Good To Know Popup =====
(function () {
  const COOKIE_NAME = "gtk_popup_dismissed";
  const DELAY_MS = 5000;

  function getCookieValue(name) {
    const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
  }

function setDismissedCookie() {
  const expires = new Date(Date.now() + 3 * 864e5).toUTCString();
  document.cookie = COOKIE_NAME + "=1; expires=" + expires + "; path=/";
}

  function dismissPopup(overlay) {
    overlay.style.animation = "gtk-fade-in 0.25s ease reverse both";
    setTimeout(function () {
      overlay.style.display = "none";
    }, 250);
    setDismissedCookie();
  }

  function initGtkPopup() {
    if (getCookieValue(COOKIE_NAME) === "1") return;

    const overlay = document.getElementById("good-to-know-popup");
    if (!overlay) return;

    setTimeout(function () {
      overlay.style.display = "flex";

      const closeBtn = document.getElementById("gtk-popup-close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          dismissPopup(overlay);
        });
      }

      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) dismissPopup(overlay);
      });
    }, DELAY_MS);
  }

  if (document.readyState === "complete") {
    initGtkPopup();
  } else {
    window.addEventListener("load", initGtkPopup, { once: true });
  }
}());
